import {
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { itemTypes } from "../../data/types/itemTypes";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import SaveIcon from "@mui/icons-material/Save";
import PrintIcon from "@mui/icons-material/Print";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ArticleIcon from "@mui/icons-material/Article";
import FolderIcon from "@mui/icons-material/Folder";
import BlockIcon from "@mui/icons-material/Block";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import ChecklistIcon from "@mui/icons-material/Checklist";
import { colors } from "../../data/colors";
import { useTranslation } from "react-i18next";
import { msgMainTypes } from "../../data/types/msgMainTypes";
import { stdObject } from "../../data/types/stdObject";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import {
  adultAge,
  checkFields,
  directDocData,
  emptys,
  extraListCodes,
  headerCodes,
  integerType,
  itemsAutoStock,
  mainDataHandle,
  personsCodes,
  purchasesCodes,
  salesCodes,
  shortcutCodes,
  staffNames,
  titleTexts,
  versionsAccess,
} from "../../data/main";
import { sendData } from "../../services/sendData";
import {
  deletePersonItemData,
  updateRowData,
  updateHeaders,
  updateUsersList,
  updateRolsList,
  addRolList,
  updateBrand,
  deleteBrandData,
  updateFieldData,
  updateTable,
} from "../../store/updateData";
import { arrayToObject } from "../../utils/arrayToObject";
import { callPersonItemInfo } from "../../services/callPersonItemInfo";
import { callPaymentsInfo } from "../../services/callPaymentsInfo";
import { savePaymentsInfo } from "../../services/savePaymentsInfo";
import { objectToArray } from "../../utils/objectToArray";
import { convertAge } from "../../utils/convertAge";
import { callDocInfo } from "../../services/callDocInfo";
import { toPrice } from "../../utils/toPrice";
import { applyDiscount } from "../../utils/applyDiscount";
import { convertDictData } from "../../utils/convertDictData";
import { getPricesList } from "../../utils/getPricesList";
import { recountTotals } from "../../utils/recountTotals";
import { writeTax } from "../../utils/writeTax";
import { getTaxList } from "./functions/getTaxList";
import { openInnerSelection } from "./functions/openInnerSelection";
import { docValueType } from "./functions/docValueType";
import { updateWindowValue } from "./functions/updateWindowValue";
import { inputIssuesType } from "./functions/inputIssuesType";
import {
  checkActiveDoc,
  removeActiveDoc,
  saveActiveDoc,
} from "../../utils/activeDocs";
import secureLocalStorage from "react-secure-storage";
import { checkIfObject } from "../../utils/checkIfObject";
import { validFormat } from "../../utils/validFormat";
import { getInputFormat } from "./functions/getInputFormat";
import { headerTitles, areasTitles } from "../../data/admin";
import { arrangeDocData } from "./functions/arrangeDocData";
import { updateIssue } from "./functions/updateIssue";
import { filterTableList } from "./functions/filterTableList";
import { checkAccess } from "./functions/checkAccess";
import { getCurrentMonth } from "../../utils/getCurrentMonth";
import { getKey } from "../../utils/getKey";
import { getInputMainData } from "./functions/getInputMainData";
import { getPriceOrOffer } from "./functions/getPriceOrOffer";
import { getPrefix } from "../../utils/getPrefix";
import { selectUsersList } from "./functions/selectUsersList";
import { saveWebInfo } from "./functions/web/saveWebInfo";
import { versionsType } from "../../data/types/versionsType";
import { createGuarantee } from "./functions/document/createGuarantee";
import { updateCommissions } from "./functions/commissions/updateCommissions";
import { createCommision } from "./functions/commissions/createCommision";
import { savePersonItemData } from "./functions/savePersonItemData";
import { updateInternalPerson } from "./functions/updateInternalPerson";
import { updateInternalItem } from "./functions/updateInternalItem";
import { returnModal } from "./data/returnModal";
import { occasionalModal } from "./data/occasionalModal";
import { mainDataModal } from "./data/mainDataModal";
import { catModal } from "./data/catModal";
import { langModal } from "./data/langModal";
import { timeModal } from "./data/timeModal";
import { transferModal } from "./data/transferModal";
import { deleteItemModal } from "./data/deleteItemModal";
import { paymentsModal } from "./data/paymentsModal";
import { printFieldsModal } from "./data/printFieldsModal";
import { itemOptionsModal } from "./data/itemOptionsModal";
import { serviceModal } from "./data/serviceModal";
import { changeBranchModal } from "./data/changeBranchModal";
import { directReload } from "./functions/directReload";
import { startSaveDocument } from "./functions/startSaveDocument";
import { startAction } from "./functions/startAction";
import { ageToString } from "../../utils/ageToString";
import { newNotificationsModal } from "./data/newNotificationsModal";
import { itemBatchesModal } from "./data/itemBatchesModal";
import { dictionaryModal } from "./data/dictionaryModal";
import { inventoryModal } from "./data/inventoryModal";
import { rolInfoModal } from "./data/rolInfoModal";
import { accessLogModal } from "./data/accessLogModal";
import { userInfoModal } from "./data/userInfoModal";
import { getCurrentTime } from "../../utils/getCurrentTime";
import { getItemType } from "../../utils/getItemType";
import { openStationery } from "./functions/stationery/openStationery";
import { getCurrentDate } from "../../utils/getCurrentDate";
import { newCalendarModal } from "./data/newCalendarModal";
import { cloneStationeryModal } from "./data/cloneStationeryModal";
import { exportStaModal } from "./data/exportStaModal";
import { voidDocModal } from "./data/voidDocModal";
import { approveCommModal } from "./data/approveCommModal";
import { webSettingsModal } from "./data/webSettingsModal";
import { fieldInfoModal } from "./data/fieldInfoModal";
import { openRolInfo } from "./functions/rol/openRolInfo";
import { DataState } from "../../store/types/initialState";
import { docFieldsModal } from "./data/docFieldsModal";
import { createAutomaticBackup } from "./functions/createAutomaticBackup";
import { updatePersonDocData } from "./functions/document/updatePersonDocData";
import { updateItemDocData } from "./functions/document/updateItemDocData";
import { docCustomersCodes, docIdCodes } from "../../data/docCodes";
import convertDate from "../../utils/convertDate";

let dictCounter: any = false;

let syncCounter = {};

export default function useMainFrame({
  logoutAction,
}: {
  logoutAction: () => void;
}) {
  const cVersion = process.env.REACT_APP_VERSION as versionsType;
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const user: any = useSelector((state: RootState) => state.data.user);
  const sucsList: Array<stdObject> = useSelector(
    (state: RootState) => state.data.suc,
  );
  const brandsList: stdObject[] = useSelector(
    (state: RootState) => state.data.brands,
  );
  const rolsList: Array<stdObject> = useSelector(
    (state: RootState) => state.data.rol,
  );
  const routesList: Array<stdObject> = useSelector(
    (state: RootState) => state.data.rut,
  );
  const userAccess: stdObject = useSelector(
    (state: RootState) => state.data.userAccess,
  );
  const usersList: stdObject = useSelector(
    (state: RootState) => state.data.usersList,
  );
  const usersListArray: stdObject[] = objectToArray("CODUSU", usersList).filter(
    (e: stdObject) => e.ACTIVO,
  );
  const personItemField: Array<stdObject> = useSelector(
    (state: RootState) => state.data.per,
  );
  const syncData: stdObject = useSelector(
    (state: RootState) => state.data.sync,
  );
  const searchList: any = useSelector((state: RootState) => state.data.search);
  const taxesList: any = useSelector((state: RootState) =>
    state.data.imp.filter((e: stdObject) => e.CODIMP === user.CODPAI),
  );
  const pricesRates: any = useSelector((state: RootState) => state.data.tar);
  const cPayments: any = useSelector((state: RootState) => state.data.ctpa);
  const vPayments: any = useSelector((state: RootState) => state.data.vtpa);
  const issuesList: any = useSelector((state: RootState) => state.data.sda);
  const formatsList: any = useSelector((state: RootState) => state.data.for);
  const warehouses: stdObject[] = useSelector(
    (state: RootState) => state.data.alm,
  );
  const countries: Array<stdObject> = useSelector(
    (state: RootState) => state.data.pai,
  );
  const bankAccountsList: Array<stdObject> = useSelector(
    (state: RootState) => state.data.bankAccounts,
  );
  const expensesList: Array<stdObject> = useSelector(
    (state: RootState) => state.data.expenses,
  );
  const items: any = useSelector((state: RootState) => state.data.art);
  const staffList: Array<stdObject> = useSelector(
    (state: RootState) => state.data.staff,
  );
  const dictList: stdObject = useSelector(
    (state: RootState) => state.data.dictList,
  );
  const interventions = objectToArray("CODART", items).filter(
    (e: stdObject) => e.TIPART === 1,
  );
  const guarantees = objectToArray("CODART", items).filter(
    (e: stdObject) => e.TIPART === 5,
  );
  const sellerList = objectToArray("CODUSU", usersList).filter(
    (e: stdObject) => e.COMROL === 0 && e.ACTIVO,
  );
  const helperList = objectToArray("CODUSU", usersList).filter(
    (e: stdObject) => e.COMROL === 1 && e.ACTIVO,
  );
  const tecnicList = objectToArray("CODUSU", usersList).filter(
    (e: stdObject) => e.COMROL === 2 && e.ACTIVO,
  );
  const statusDict: stdObject = arrayToObject({
    key: "CODPAG",
    erase: ["CODPAG"],
    data: searchList.docStatus,
  });
  const [selectMode, setSelectMode] = useState<stdObject>({
    active: false,
    searchParams: {},
    serviceStep: 0,
    backMenu: "",
    goMenu: "",
    target: "",
    search: "",
    code: "",
  });
  const listCodeRef = useRef("");
  const documentAction = useRef<stdObject>({});
  const customUpdate = useRef({});
  const [msg, setMsg] = useState<string>("");
  const [msg2, setMsg2] = useState<string>("");
  const [msg3, setMsg3] = useState<string>("");
  const [currentDate, setCurrentDate] = useState(getCurrentMonth());
  const [calDocsList, setCalDocsList] = useState<stdObject[]>([]);
  const [activeDoc, setActiveDoc] = useState(0);
  const [alarms, setAlarms] = useState(0);
  const [docModal, setDocModal] = useState<string>("");
  const [stationeryModal, setStationeryModal] = useState<string>("");
  const [calendarModal, setCalendarModal] = useState<stdObject>({});
  const [docValues, setDocValues] = useState<stdObject>({});
  const [windowValues, setWindowValues] = useState<stdObject>({});
  const [windowValues2, setWindowValues2] = useState<stdObject>({});
  const [activeDocList, setActiveDocList] = useState<Array<stdObject>>([]);
  const [modalData, setModalData] = useState<stdObject>({
    label: "",
    code: "",
    isEdit: false,
    type: "",
    inputs: [],
    buttons: [],
  });
  const [modalData2, setModalData2] = useState<stdObject>({
    icon: "",
    title: "",
    label: "",
  });
  const [modalData3, setModalData3] = useState<stdObject>({
    icon: "",
    title: "",
    label: "",
  });

  const [mainMenuheader, setMainMenuHeader] = useState<itemTypes>({
    type: false,
    id: "",
    Icon: CheckBoxOutlineBlankIcon,
  });

  const packInnerSelection = useMemo(
    () => ({
      t,
      setMsg,
      setWindowValues,
      setModalData,
    }),
    [t, setMsg, setWindowValues, setModalData],
  );

  const packUpdateWindow = {
    windowValues,
    setWindowValues,
    windowValues2,
    setWindowValues2,
  };

  const packArrangeDoc = { t, warehouses, user, statusDict, staffList };

  const packFilterTable = {
    windowValues,
    setWindowValues,
    modalData,
    dictList,
  };

  const packCheckAccess = { docValues, userAccess };

  const packInputFormat = {
    t,
    modalData,
    searchList,
    pricesRates,
    formatsList,
    usersList,
    rolsList,
    routesList,
    sucsList,
    brandsList,
    bankAccountsList,
    getInputFormat,
  };

  const packTransfer = {
    modalData,
    setModalData,
    items,
    docValues,
    country: user.CODPAI,
  };

  const updateListCodeRef = (code: string) => {
    listCodeRef.current = code;
  };

  const startSendData = async (endPoint: string, payload: stdObject) =>
    await sendData({ endPoint, payload, logoutAction });

  const liveData = async () => {
    // console.log("syncCounter", listCodeRef.current, syncCounter);
    const token = secureLocalStorage.getItem("token");
    if (!token) return;
    try {
      const payloadLiveData = {
        branch: user.CODSUC,
        dates: syncCounter,
        date: getCurrentDate(true),
      };
      // console.log("payloadLiveData", payloadLiveData);
      const resultInfo: stdObject = await startSendData(
        "live",
        payloadLiveData,
      );
      // console.log("resultInfo", resultInfo);

      Object.keys(resultInfo.list).forEach(async (e: string) => {
        if (extraListCodes.includes(e)) {
          resultInfo.list[e]
            .filter((v: stdObject) => v.L_DELETE === 1)
            .forEach((v: stdObject) => {
              if (e === "ART") {
                dispatch(
                  deletePersonItemData({
                    type: e.toLowerCase() as keyof RootState["data"],
                    code: v.L_CODE,
                  }),
                );
              } else {
                dispatch(
                  updateRowData({
                    type: e,
                    data: [{ deleteCode: v.L_CODE }],
                  }),
                );
              }
            });
        }

        const getDatasInfo: stdObject = await startSendData("liveReturnData", {
          type: e,
          codes: extraListCodes.includes(resultInfo.list[e])
            ? resultInfo.list[e]
                .filter((v: stdObject) => v.L_DELETE === 0)
                .map((v: stdObject) => v.L_CODE)
            : resultInfo.list[e].map((v: stdObject) => v.L_CODE),
        });

        // console.log("getDatasInfo", getDatasInfo);

        if (extraListCodes.includes(e) || e === "CAB") {
          getDatasInfo.dataList.forEach((v: stdObject) => {
            if (e === "CAB") {
              dispatch(
                updateHeaders({
                  data: v.data.filter(
                    (e: stdObject) =>
                      e.USUCAB === 0 || e.USUCAB === user.CODUSU,
                  ),
                }),
              );
            } else if (personsCodes.includes(e)) {
              updateInternalPerson(v, e, dispatch);
            } else {
              updateInternalItem(v, e, dispatch);
            }
          });
        } else if (listCodeRef.current === e) {
          dispatch(
            updateRowData({
              type: e,
              data:
                "dataList" in getDatasInfo &&
                getDatasInfo.dataList.map((o: stdObject) => o.data),
            }),
          );
        }
      });

      syncCounter = resultInfo.sync.reduce(
        (acc: stdObject, curr: stdObject) => {
          acc[curr.KEYCODE] = curr.TIMELIVE;
          return acc;
        },
        {},
      );

      if (resultInfo.backup) {
        createAutomaticBackup(resultInfo.backup, { logoutAction });
      }

      setTimeout(liveData, 5000);
    } catch (error) {
      console.log("liveData error: ", error);
      setTimeout(liveData, 20000);
    }
  };

  useEffect(() => {
    syncCounter = syncData;
    // liveData();
    const raw = secureLocalStorage.getItem("tempDocs");
    if (checkIfObject(raw)) {
      const key = String(user.CODUSU);
      const typedRaw = raw as Record<string, any>;
      if (key in typedRaw) {
        setActiveDoc(Object.keys(typedRaw[key]).length);
      }
    }
  }, []);

  const openMsg = (key: string, data: stdObject) => {
    setMsg(key);
    setModalData2(data);
  };

  const openWindow = async ({
    msgName,
    modalInfo,
    level = 0,
  }: {
    msgName: string;
    modalInfo: stdObject;
    level?: number;
  }) => {
    // console.log("openWindow", { msgName, modalInfo, level });
    let tempFunc =
      level === 1
        ? {
            setMsg: setMsg2,
            setModalData: setModalData2,
            setWindowValues: setWindowValues2,
          }
        : { setMsg, setModalData, setWindowValues };

    let resultInfo: any = false;

    if (
      (modalInfo.code !== "" && msgName === "document") ||
      ["personItem", "payments"].includes(msgName)
    ) {
      tempFunc.setMsg("loading");
      switch (msgName) {
        case "personItem":
          resultInfo = await callPersonItemInfo(
            modalInfo,
            personItemField.filter(
              (e) => e.TIPPER === modalInfo.doc && e.ACTPER === 1,
            ),
            { logoutAction, countries, taxesList },
          );
          break;
        case "payments":
          resultInfo = await callPaymentsInfo(modalInfo, logoutAction);
          break;
        case "document":
          resultInfo = checkActiveDoc(user.CODUSU, {
            type: modalInfo.doc,
            serie: modalInfo.serie,
            code: modalInfo.code,
          });
          if (!resultInfo) {
            resultInfo = await callDocInfo({
              user,
              type: modalInfo.doc,
              serie: modalInfo.serie,
              code: modalInfo.code,
              mainColor: modalInfo.mainColor,
              logoutAction,
            });
            if (resultInfo.prev[`EST3${resultInfo.type}`] === 0) {
              saveActiveDoc(user.CODUSU, {
                ...resultInfo,
                sectionId: modalInfo.type,
              });
              setActiveDoc(activeDoc + 1);
            }
          }
          break;
        default:
          resultInfo = {};
          break;
      }
      if (resultInfo.data?.blocked) {
        msgName = "error";
        setModalData2({ label: t(`p.${resultInfo.data.blocked}`) });
      } else {
        if (resultInfo.data) {
          if (msgName === "document") {
            if (resultInfo.prev[`EST3${resultInfo.type}`] === 0) {
              dispatch(
                updateRowData({
                  type: resultInfo.type,
                  data: [resultInfo.data],
                }),
              );
              resultInfo = {
                ...resultInfo,
                data: {
                  ...resultInfo.data,
                  [`EST3${resultInfo.type}`]:
                    resultInfo.prev[`EST3${resultInfo.type}`],
                },
              };
            }
          } else {
            if (
              "TAR" in resultInfo.data &&
              emptys.includes(resultInfo.data.TAR)
            ) {
              resultInfo.data.TAR =
                pricesRates.length > 0 ? pricesRates[0].CODTAR : 1;
            }
            tempFunc.setWindowValues({ ...resultInfo.data });
          }
        } else {
          //tempFunc.setModalData({ label: resultInfo.error });
          setModalData2({ label: resultInfo.error });
          tempFunc.setMsg("error");
          return false;
        }
      }
    } else if (msgName !== "selectiveWindow") {
      resultInfo = await callDocInfo({
        user,
        type: modalInfo.doc,
        serie: user.CODSUC,
        code: 0,
        person: modalInfo.docData?.person ?? "",
        staff: modalInfo.docData?.staff ?? "",
        items: modalInfo.docData?.items ?? "",
        mainColor: modalInfo.mainColor,
        initial: {
          SER: user.CODSUC,
          CRE: user.CODUSU,
          CNO: user.NOMUSU,
          AGE: user.VENTAS ? user.CODUSU : 0,
          ANO: user.VENTAS ? user.NOMUSU : "",
          ...(modalInfo.docData?.initial ?? {}),
        },
        logoutAction,
      });

      saveActiveDoc(user.CODUSU, {
        ...resultInfo,
        sectionId: modalInfo.type,
      });
      setActiveDoc(activeDoc + 1);

      tempFunc.setWindowValues({});
    }

    if (msgName === "selectiveWindow") {
      selectStep(0, "", {
        type: modalInfo.doc,
        color: modalInfo.mainColor,
        sectionId: modalInfo.type,
        nextDate: modalInfo.nextDate,
      });
    } else if (["doc", "document"].includes(msgName)) {
      resultInfo = arrangeDocData(resultInfo, packArrangeDoc, writeDataParams);
      setDocValues({
        ...resultInfo,
        sectionId: modalInfo.type,
        typeText: modalInfo.typeText,
        title:
          resultInfo.code > 0
            ? `${
                ["SAL", "PRE"].includes(resultInfo.type)
                  ? t(`c.${resultInfo.type}P`)
                  : t(`c.${resultInfo.type}`)
              } ${resultInfo.serie}-${resultInfo.code}`
            : t(`p.new${modalInfo.doc}`, { code: t(`c.${modalInfo.doc}`) }),
      });
    } else {
      if (modalInfo.type === "F2") modalInfo.type = "ART";
      tempFunc.setModalData(modalInfo);
    }
    if (["doc", "document"].includes(msgName)) {
      setDocModal("document");
      if (
        resultInfo.data[`EST3${resultInfo.type}`].value === 1 &&
        resultInfo.data[`ABR${resultInfo.type}`].value !== user.CODUSU
      ) {
        tempFunc.setMsg("custom1");
        setModalData({
          code: "warning",
          label:
            t("p.documentInUseBy") +
            `: ${resultInfo.data[`NAB${resultInfo.type}`].value}`,
        });
      } else {
        closeMsg();
      }
    } else {
      tempFunc.setMsg(msgName);
    }
  };

  const openPaidMsg = useCallback(() => {
    setMsg("custom1");
    setModalData({
      code: "error",
      label: t("p.cantChangeCauseCommission"),
    });
  }, [t, setMsg, setModalData]);

  const openSelection = useCallback(
    (
      key: string | number,
      target: string | number,
      serviceStep: number = 0,
      searchParams = {},
    ) => {
      setSelectMode({
        ...selectMode,
        serviceStep,
        goMenu: key,
        target,
        active: true,
        searchParams,
      });
      setDocModal("");
    },
    [selectMode, setSelectMode, setDocModal],
  );

  const writeDataParams = useCallback(
    ({
      type,
      key,
      value,
      itemCode,
      name,
      field,
      hideCode,
      paid,
      active = true,
      options,
    }: stdObject) => {
      const writeOptions = () => {
        if (key in directDocData && directDocData[key].type === "select") {
          switch (key) {
            case "ALM2":
              return options;
            case "PRE":
              return getPricesList({
                type,
                value,
                pricesList: items[itemCode]?.PREART[user.CODPAI],
                pricesRates,
                label: t("p.another"),
                titles: true,
                user,
              });
            case "PIM":
              return getTaxList(value, taxesList);
            default:
              if (directDocData[key].type === "select") {
                return searchList[directDocData[key].options]
                  .filter(
                    (v: stdObject) =>
                      v[`ACT${directDocData[key].code ?? key}`] === 1,
                  )
                  .map((v: stdObject) => {
                    return {
                      label: v[`NOM${directDocData[key].code ?? key}`],
                      value: v[`COD${directDocData[key].code ?? key}`],
                    };
                  });
              }
          }
        }
        return [];
      };

      return {
        ...docValueType(
          key.toString(),
          purchasesCodes.includes(type)
            ? key === "CLI"
              ? t(`d.PRO`)
              : key === "FEC2"
                ? t(`d.FEC2P`)
                : t(`d.${key}`)
            : t(`d.${key}`),
        ),
        key,
        field,
        active,
        onClick: [...extraListCodes, "RES"].includes(key.toString())
          ? () =>
              openSelection(
                purchasesCodes.includes(type)
                  ? "PRO"
                  : key === "RES"
                    ? "CLI"
                    : key,
                key,
              )
          : !user.SELVEN && field === "staff"
            ? () => setMsg2("accessBlocked")
            : paid
              ? openPaidMsg
              : (data: stdObject) =>
                  openInnerSelection({
                    key,
                    data,
                    value,
                    itemCode,
                    ...packInnerSelection,
                    tableList:
                      key === "PSE"
                        ? searchList.docInsurances
                        : key === "PAG"
                          ? searchList.docStatus
                          : key === "INT"
                            ? interventions
                            : selectUsersList(key, {
                                helperList,
                                tecnicList,
                                sellerList,
                              }),
                  }),
        value,
        options: writeOptions(),
        name,
        hideCode,
      };
    },
    [
      interventions,
      warehouses,
      items,
      packInnerSelection,
      pricesRates,
      searchList,
      sellerList,
      t,
      taxesList,
      user,
      openPaidMsg,
      openSelection,
    ],
  );

  const closeMsg = useCallback(
    (level: number = 1) => {
      switch (level) {
        case 2:
          setMsg2("");
          break;
        case 3:
          setMsg3("");
          break;
        default:
          setMsg("");
          break;
      }
    },
    [setMsg, setMsg2, setMsg3],
  );

  const closeCalendar = () => {
    setCalendarModal({ ...calendarModal, open: false });
  };

  const closeMsgDoc = async (action: boolean | string = false) => {
    const idCode = docIdCodes[docValues.type];
    if (!action && docValues.updated && userAccess[idCode[0]][idCode] > 1) {
      setMsg("askToClose");
    } else {
      if (action !== "min") {
        setActiveDoc(removeActiveDoc(user.CODUSU, docValues.id));

        if (docValues.data[`EST3${docValues.type}`].value === 0) {
          startLoading();
          const responseReleaseDoc: stdObject = await startSendData(
            "releaseDocument",
            {
              type: docValues.type,
              serie: docValues.data[`SER${docValues.type}`].value,
              code: docValues.data[`COD${docValues.type}`].value,
              user: docValues.data[`AGE${docValues.type}`]?.value,
              // updated: docValues.updated,
            },
          );
          dispatch(
            updateRowData({
              type: responseReleaseDoc.type,
              data: [responseReleaseDoc.data],
            }),
          );
        }
      }
      setDocModal("");
      setDocValues({});
      closeMsg();
      documentAction.current = {};
    }
  };

  const askLogout = () => setMsg("askLogout");
  const startLoading = () => setMsg("loading");
  const changeBranch = () => setMsg("changeBranchModal");

  const openServiceModal = ({ nextDate }: stdObject) => {
    setMsg("serviceModal");
    setWindowValues({ service: { FEC2: `${nextDate} ${getCurrentTime()}` } });
    setModalData({
      mainColor: colors.service,
      inputs: [
        ["INT", "INTN", "ART", "c.INT"],
        ["CLI", "NOM", "CLI", "c.CLI"],
        ["RES", "NRS", "RES", "p.invoiceTo"],
        ["AGE", "ANO", "USU", "c.AGE"],
        ["FEC2", "", "", "c.FEC2"],
      ].map((e: string[]) => {
        return {
          code: e[0],
          name: e[1],
          searchType: e[2],
          label: e[0] === "FEC2" ? t(e[3]) : t(e[3]),
          type: e[0] === "FEC2" ? "datetime-local" : "innerButton",
        };
      }),
    });
  };

  const deleteData = async (active: boolean = false) => {
    if (active) {
      setMsg3("loading");

      const responseDeletePersonItem: stdObject = await startSendData(
        modalData2.type === "ART" ? "deleteItem" : "deletePerson",
        {
          type: modalData2.type,
          code: modalData2.code,
        },
      );
      console.log(
        "responseDeletePersonItem",
        responseDeletePersonItem,
        Object.keys(responseDeletePersonItem)
          .map((e) => responseDeletePersonItem[e])
          .join(""),
      );
      if (responseDeletePersonItem.success) {
        if (responseDeletePersonItem.status) {
          closeMsg(3);
          closeMsg(2);
          setWindowValues2({});

          if (modalData2.type === "ART") {
            dispatch(
              deletePersonItemData({
                type: modalData2.type.toLowerCase(),
                code: modalData2.code,
              }),
            );
          } else {
            dispatch(
              updateRowData({
                type: modalData2.type,
                data: [{ deleteCode: modalData2.code }],
              }),
            );
          }
        } else {
          setMsg3("error");
          setModalData2({ label: responseDeletePersonItem.error });
        }
      } else {
        setMsg3("error");
      }
    } else {
      setMsg3("custom3");
      setModalData3({
        label:
          modalData2.type === "ART"
            ? t("p.askDeleteItem", { thisItem: t("p.thisItem").toLowerCase() })
            : modalData2.type === "CLI"
              ? t("p.askDeleteCustomer", {
                  thisCustomer: t("p.thisCustomer").toLowerCase(),
                })
              : t("p.askDeleteSupplier", {
                  thisSupplier: t("p.thisSupplier").toLowerCase(),
                }),
        buttons: [
          {
            label: t("p.delete"),
            onClick: () => deleteData(true),
            color: colors.red,
          },
          {
            label: t("p.cancel"),
            onClick: () => closeMsg(3),
            color: colors.darkGrey,
          },
        ],
      });
    }
  };

  const saveMainInfo = async () => {
    const mainType = ["CTPA", "VTPA"].includes(modalData.type)
      ? "TPA"
      : modalData.type;
    if (windowValues.info[`NOM${mainType}`].trim() === "") {
      setMsg2("custom2");
      setModalData2({
        code: "warning",
        label: t("p.enterAName"),
      });
    } else {
      startLoading();
      const payloadSaveMainInfo: stdObject = {
        type: modalData.type,
        info: windowValues.info,
      };
      if (mainType === "SDA") {
        payloadSaveMainInfo.forms = [];
        let counter = 0;
        while (counter > -1) {
          if (`FORSD0${counter}` in windowValues.info) {
            if (windowValues.info[`ACTSD0${counter}`]) {
              payloadSaveMainInfo.forms.push([
                windowValues.info[`FORSD0${counter}`],
                windowValues.info[`GRUSD0${counter}`],
                windowValues.info[`ORDSD0${counter}`],
              ]);
            }
            const currentCounter = counter;
            ["TITSD0", "FORSD0", "ACTSD0", "GRUSD0", "ORDSD0"].forEach(
              (e: string) => {
                delete windowValues.info[`${e}${currentCounter}`];
              },
            );
            counter++;
          } else {
            counter = -1;
          }
        }
      }
      console.log("payloadSaveMainInfo: ", payloadSaveMainInfo);
      const resultSaveMainInfo: stdObject = await startSendData(
        "saveMainInfo",
        payloadSaveMainInfo,
      );
      console.log("resultSaveMainInfo", resultSaveMainInfo);
      const { success, status, info, forms } = resultSaveMainInfo;
      if (success && status) {
        if (modalData.type === "SDA") {
          info[0].FORMAT = forms.map((v: stdObject) => v.CODFOR);
          info[0].FORSDA = forms.map((v: stdObject) => [v.NOMFOR]);
          info[0].GRUSDA = forms.map((v: stdObject) => [v.NOMFOR, v.GRUSD0]);
          info[0].ORDSDA = forms.map((v: stdObject) => [v.NOMFOR, v.ORDSD0]);
        }
        dispatch(
          updateTable({
            type: modalData.type.toLowerCase(),
            index: modalData.index,
            data: info[0],
          }),
        );
      }
      closeMsg();
    }
  };

  const saveHeaderInfo = async () => {
    startLoading();
    const payloadHeader = {
      info: windowValues.info,
    };
    console.log("payloadHeader: ", payloadHeader);
    const resultHeader: stdObject = await startSendData(
      "saveHeader",
      payloadHeader,
    );
    console.log("resultHeader", resultHeader);
    if (resultHeader.success) {
      customUpdate.current = {
        header: modalData.index,
        info: resultHeader.info,
      };
    }
    closeMsg();
  };

  const saveUserInfo = async () => {
    const accountResult = validFormat(
      windowValues.info.ACCUSU ? windowValues.info.ACCUSU.trim() : "",
      {
        minLength: 5,
        noSpecials: true,
        noSpaces: true,
      },
    );
    const nameResult = validFormat(
      windowValues.info.NOMUSU ? windowValues.info.NOMUSU.trim() : "",
      {
        minLength: 5,
      },
    );
    const emailResult = validFormat(
      windowValues.info.EMAUSU ? windowValues.info.EMAUSU.trim() : "",
      {
        email: true,
      },
    );

    let errorMsg = "";

    const userAlreadyExist = Object.entries(usersList)
      .filter(([key]) => key !== modalData.id)
      .some(
        ([_, e]) =>
          e.ACCUSU.trim().toLowerCase() === accountResult.value.toLowerCase() ||
          e.NOMUSU.trim().toLowerCase() === nameResult.value.toLowerCase(),
      );
    if (userAlreadyExist) {
      errorMsg = t("p.userAlreadyExists");
    } else if (!accountResult.success) {
      errorMsg = t("c.ACC") + ": ";
      switch (accountResult.errorTypes[0]) {
        case "isEmpty":
          errorMsg += t("p.isEmpty");
          break;
        case "minLength":
          errorMsg += t("p.minimumCharacters", { number: 5 });
          break;
        case "noSpecials":
          errorMsg += t("p.specialsNotAllowed");
          break;
        case "noSpaces":
          errorMsg += t("p.spacesNotAllowed");
          break;
      }
    } else if (!nameResult.success) {
      errorMsg = t("c.NOM") + ": ";
      switch (accountResult.errorTypes[0]) {
        case "isEmpty":
          errorMsg += t("p.isEmpty");
          break;
        case "minLength":
          errorMsg += t("p.minimumCharacters", { number: 5 });
          break;
      }
    } else if (emailResult.value.length > 0 && !emailResult.success) {
      errorMsg = t("p.emailIsIncorrect");
    } else {
      errorMsg = findIpError();
    }

    if (errorMsg.length > 0) {
      setMsg2("custom2");
      setModalData2({
        code: "warning",
        label: errorMsg,
      });
    } else if (
      accountResult.success &&
      nameResult.success &&
      !userAlreadyExist
    ) {
      startLoading();
      const payloadUser = {
        id: modalData.id,
        info: windowValues.info,
        ip: windowValues.ip,
      };
      console.log("payloadUser: ", payloadUser);
      const resultUser: stdObject = await startSendData(
        "saveUser",
        payloadUser,
      );
      console.log("resultUser", resultUser);
      console.log("resultUser", Object.values(resultUser).join(""));
      if (resultUser.success && resultUser.info[0]) {
        dispatch(
          updateUsersList({
            type: resultUser.id,
            data: resultUser.info[0],
          }),
        );
      }
      closeMsg();
    }
  };

  const findIpError = () =>
    windowValues.ip.some((e: stdObject) => e.CODIP.trim() === "")
      ? "p.ipIsEmpty"
      : windowValues.ip.some(
            (e: stdObject) =>
              [0, 1, 2].includes(e.LOCIP) &&
              (e.CODIP.split(".").length !== 4 ||
                e.CODIP.split(".").some((e: string) => isNaN(Number(e)))),
          )
        ? "p.ipIsIncorrect"
        : "";

  const saveFieldInfo = async () => {
    setMsg2("loading");
    const resultField: stdObject = await startSendData(
      "saveField",
      windowValues,
    );
    const { success, status } = resultField;
    if (success && status) {
      dispatch(
        updateFieldData({
          data: windowValues,
        }),
      );
    }
    setWindowValues({});
    closeMsg();
    closeMsg(2);
  };

  const saveRolInfo = async () => {
    let errorLabel =
      windowValues.info.NOMROL.trim().length === 0
        ? "p.enterAName"
        : findIpError();

    if (errorLabel === "") {
      startLoading();
      const payloadRol = {
        id: modalData.id,
        ...windowValues,
      };
      console.log("payloadRol: ", payloadRol);
      const resultRol: stdObject = await startSendData("saveRol", payloadRol);
      console.log("resultRol", resultRol);
      if (resultRol.success && resultRol.info[0]) {
        if (modalData.id === "" && resultRol.id > 0) {
          dispatch(addRolList({ data: resultRol.info[0] }));
        } else if (resultRol.id > 0) {
          dispatch(
            updateRolsList({
              type: resultRol.id,
              data: resultRol.info[0],
            }),
          );
        }
      }
      setModalData({});
      setWindowValues({});
      closeMsg();
    } else {
      setMsg2("custom2");
      setModalData2({
        code: "warning",
        label: t(errorLabel),
      });
    }
  };

  const checkIfAllMsgClean = (level = 1) => {
    switch (level) {
      case 2:
        return msg + msg2 + msg3 === "";
      default:
        return msg + msg2 + msg3 + docModal + stationeryModal === "";
    }
  };

  const openErrorMsg = (msgInfo: stdObject, level = 0) => {
    if (level === 1) {
      setMsg3("custom3");
      setModalData3(msgInfo);
    } else {
      setMsg2("custom3");
      setModalData2(msgInfo);
    }
  };

  const startSavePayments = async () => {
    setMsg2("loading");
    const updatedInfo: stdObject = await savePaymentsInfo(
      windowValues,
      salesCodes.includes(windowValues.type) ? vPayments : cPayments,
      logoutAction,
    );
    if (updatedInfo.data) {
      if (updatedInfo.type === "COYP") {
        customUpdate.current = {
          area: "commissions",
          id: updatedInfo.data.AGECOYP,
          code: updatedInfo.data.CODCOYP,
          key: "BUTTONCOYP",
          value: {
            style: {
              color:
                updatedInfo.data.ESTCOYP === 2
                  ? colors.green
                  : updatedInfo.data.ESTCOYP === 1
                    ? colors.orange
                    : colors.grey,
            },
            onClick: () =>
              openWindow({
                msgName: "payments",
                modalInfo: {
                  title: t("p.commission"),
                  label: `${updatedInfo.data.NOMCOYP} (${updatedInfo.data.CODCOYP})`,
                  type: "COYP",
                  doc: "COYP",
                  isEdit: true,
                  serie: updatedInfo.data.SERCOYP,
                  code: updatedInfo.data.CODCOYP,
                },
              }),
          },
        };
      } else {
        dispatch(
          updateRowData({
            type: updatedInfo.type,
            data: [updatedInfo.data],
          }),
        );
      }
      closeMsg(2);
      closeMsg();
      setWindowValues({});
    } else {
      setMsg2(updatedInfo.error);
    }
  };

  const deleteMainData = async (accepted: boolean = false) => {
    const handleParams = mainDataHandle[modalData.key];
    if (accepted) {
      setMsg2("loading");
      const payloadDeleteMainData = {
        area: modalData.area,
        type: modalData.key,
        name: modalData.name,
        id: modalData.code,
      };
      console.log(
        "payloadDeleteMainData",
        handleParams.deleteUrl,
        payloadDeleteMainData,
      );
      const responseDeleteMainData: stdObject = await sendData({
        endPoint: handleParams.deleteUrl,
        payload: payloadDeleteMainData,
        logoutAction,
      });
      console.log("responseDeleteMainData", responseDeleteMainData);
      if (responseDeleteMainData.success && responseDeleteMainData.status) {
        switch (modalData.key) {
          case "MAR":
            dispatch(deleteBrandData({ code: responseDeleteMainData.id }));
            break;
          case "DIN":
          case "CAJ":
            customUpdate.current = {
              mainInfo: modalData.key,
              info: windowValues,
            };
            break;
        }
        closeMsg();
        closeMsg(2);
        setWindowValues({});
        setModalData({});
      } else {
        setMsg("error");
      }
    } else {
      setMsg2("custom2");
      setModalData2({
        code: "warning",
        label: t(handleParams.askDelete),
        buttons: [
          {
            label: t("p.delete"),
            onClick: () => deleteMainData(true),
            color: colors.red,
          },
          {
            label: t("p.cancel"),
            onClick: () => closeMsg(2),
            color: colors.darkGrey,
          },
        ],
      });
    }
  };

  const selectStep = async (
    step: number,
    value: string | stdObject,
    modalInfo: stdObject = {},
  ) => {
    let skipStep = false;
    if (step === 2) {
      if (typeof value === "object") {
        const cusAge = convertAge(value.NACCLI);
        if (!cusAge || (Array.isArray(cusAge) && cusAge[0] >= adultAge)) {
          skipStep = true;
        }
      } else {
        skipStep = true;
      }
      if (skipStep) {
        step = 3;
      }
    }
    switch (step) {
      case 1: // get person data
        value = value === "" ? windowValues.intervention : value;
        openSelection("CLI", "CLI", 2);
        closeMsg();
        setWindowValues({
          ...windowValues,
          // search: "",
          intervention: value,
          // table: customersList,
        });
        setModalData({
          //title: t("p.customer"),
          label: [
            typeof value === "string" && value !== ""
              ? `${t("p.intervention")}: ${items[value]?.NOMART}`
              : null,
          ],
          step,
          // placeholder: t("p.searchByNameOrCode"),
          // keysList: ["CODCLI", "NOMCLI"],
          // codeKey: "CODCLI",
          // table: customersList,
        });
        break;
      case 2: // get assigned person if person is a minor
        value = value === "" ? windowValues.customer : value;
        openSelection("CLI", "CLI", 3);
        setMsg2("custom2");
        setModalData2({
          title: t("p.selectedPersonMinor"),
          label: t("p.doYouWishchoosePersonBill"),
          buttons: [
            {
              label: t("p.yes"),
              onClick: () => {
                closeMsg(2);
                setModalData2({});
              },
              color: colors.blue,
            },
            {
              label: t("p.no"),
              onClick: () => {
                selectStep(step + 1, "");
                setModalData2({});
                closeMsg(2);
              },
              color: colors.darkGrey,
            },
          ],
        });
        closeMsg();
        setWindowValues({
          ...windowValues,
          // search: "",
          customer: value,
          // table: newCusList,
        });
        setModalData({
          // title: t("p.invoiceTo"),
          label: [
            ...modalData.label,
            typeof value === "object" && "NOMCLI" in value
              ? `${t("p.customer")}: ${value.NOMCLI}`
              : null,
          ],
          step,
          // placeholder: t("p.searchByNameOrCode"),
          // keysList: ["CODCLI", "NOMCLI"],
          // codeKey: "CODCLI",
          // table: newCusList,
        });
        break;
      case 3: // get initial issues
        closeMsg(2);
        setWindowValues2({});
        if (selectMode.active) {
          returnToDoc();
        }
        setMsg("selectiveWindow");
        let newLabel: string | null = null;
        if (typeof value === "object") {
          setWindowValues({
            ...windowValues,
            search: "",
            [skipStep ? "customer" : "invoiceTo"]: value,
            issues: {},
            table: [],
          });
          newLabel = `${skipStep ? t("p.customer") : t("p.invoiceTo")}: ${
            value.NOMCLI
          }`;
        }
        // typeof value === "string" && value !== ""
        //   ? `${t(skipStep ? "p.customer" : "p.invoiceTo")}: ${value.NOMCLI}`
        //   : null;
        // console.log("modal", modalData);

        if (
          modalData.label.length > 0 &&
          newLabel === modalData.label[modalData.label.length - 1]
        ) {
          newLabel = null;
        }
        setModalData({
          title: t("p.issues"),
          label: newLabel ? [...modalData.label, newLabel] : modalData.label,
          step,
          inputs: issuesList.filter(
            (e: stdObject) =>
              e.ACTSDA === 1 &&
              e.INISDA === 1 &&
              ((!windowValues.intervention && e.FORSDA === 0) ||
                (typeof windowValues.intervention === "string" &&
                  e.FORSDA === items[windowValues.intervention].FORART)),
          ),
        });

        break;
      case 4: // get main seller
        setWindowValues2({
          search: "",
          table: sellerList,
        });
        setModalData({
          title: t("p.seller"),
          label: modalData.label,
          step,
          placeholder: t("p.searchByName"),
          keysList: ["NOMUSU"],
          codeKey: "CODUSU",
          table: sellerList,
        });
        break;
      case 5: // open previous message
        setMsg2("custom2");
        setModalData2({
          title: t("p.whatDoYouWantToDo"),
          buttons: [
            {
              label: t("p.open"),
              onClick: () =>
                directSaveDoc(false, Number(value === "" ? 0 : value)),
              color: colors.blue,
            },
            {
              label: t("p.saveAndClose"),
              onClick: () => {
                directSaveDoc(true, Number(value === "" ? 0 : value));
                closeMsg(2);
              },
              color: colors.green,
            },
            {
              label: t("p.cancel"),
              onClick: () => {
                setModalData2({});
                closeMsg(2);
              },
              color: colors.darkGrey,
            },
          ],
        });
        break;
      default: // get intervention
        setWindowValues({
          ...modalInfo,
          ...windowValues,
          search: "",
          table: interventions,
        });
        setModalData({
          title: t("p.intervention"),
          step: 0,
          placeholder: t("p.searchByName"),
          keysList: ["NOMART"],
          codeKey: "CODART",
          table: interventions,
        });

        if (modalInfo.nextDate) {
          setMsg2("timeModal");
          setWindowValues2({});
        }
        break;
    }
  };

  const directSaveDoc = async (
    close: boolean = false,
    sellerCode: number = 0,
  ) => {
    closeMsg(2);
    setModalData2({});
    setMsg("loading");
    const ratePrice =
      typeof windowValues.customer?.TARCLI === "number" &&
      windowValues.customer?.TARCLI > 0
        ? windowValues.customer.TARCLI
        : 1;
    const initData = {
      PRE: getPriceOrOffer({
        data: items[windowValues.intervention],
        price:
          items[windowValues.intervention]?.PREART[user.CODPAI][ratePrice]
            ?.PRELTA ?? 0,
        country: user.CODPAI,
        rate: ratePrice,
      }),
      PIM: items[windowValues.intervention]?.TAX[user.CODPAI] ?? 0,
      PCO: items[windowValues.intervention]?.PREPCO[user.CODPAI] ?? 0,
    };
    const payloadDocBase = {
      user,
      type: "SEV",
      serie: user.CODSUC,
      code: 0,
      person: windowValues.customer.CODCLI,
      issues: windowValues.issues,
      mainColor: colors.services,
      initial: {
        SER: user.CODSUC,
        FEC2: windowValues.nextDate,
        INT: windowValues.intervention ?? "",
        INTN: items[windowValues.intervention]?.NOMART ?? "",
        ...initData,
        ...["CLI", "NOM", "TEL", "CEL", "EMA1", "DOM"].reduce(
          (acc: stdObject, key: string) => {
            let value =
              key === "CLI"
                ? (windowValues.customer.CODCLI ?? "")
                : key === "DOM"
                  ? (windowValues.customer.DOMCLI[0]?.DOMDIR ?? "")
                  : (windowValues.customer[`${key}CLI`] ?? "");
            acc[key === "EMA1" ? "EMA" : key] = value;
            return acc;
          },
          {},
        ),
        NET: initData.PRE,
        IMP: initData.PRE * (initData.PIM / 100),
        TOT: initData.PRE + initData.PRE * (initData.PIM / 100),
        SAL: initData.PRE + initData.PRE * (initData.PIM / 100),
        ALM: user.CODSUC,
        AGE: sellerCode,
        ANO: sellerCode > 0 ? usersList[sellerCode].NOMUSU : "",
        CRE: user.CODUSU,
        CNO: user.NOMUSU,
        REC: user.CODUSU,
        RNO: user.NOMUSU,
        RES: "invoiceTo" in windowValues ? windowValues.invoiceTo.CODCLI : "",
        NRS:
          "invoiceTo" in windowValues
            ? (windowValues.invoiceTo.NOMCLI ?? "")
            : "",
      },
      logoutAction,
    };
    const responseDocBase: stdObject = await callDocInfo(payloadDocBase);
    if (responseDocBase.id) {
      const comm =
        sellerCode > 0 && windowValues.intervention.length > 0
          ? createCommision({
              id: sellerCode,
              name: usersList[sellerCode].NOMUSU,
              group: 0,
              itemCode: windowValues.intervention,
              item:
                windowValues.intervention in items
                  ? items[windowValues.intervention]
                  : false,
              data: {
                LINSE0: 0,
                CANSE0: 1,
                ARTSE0: windowValues.intervention,
                NOMSE0: items[windowValues.intervention].NOMART,
                PRESE0: initData.PRE,
              },
              docValues: {
                type: windowValues.type,
                itemType: "SE0",
                data: {
                  SERSEV: { value: user.CODSUC },
                  CODSEV: { value: 0 },
                },
              },
            })
          : false;
      responseDocBase.commissions = comm ? [comm] : [];
      const newStaff = staffList.filter((e: stdObject) => e.DOCIA1 === "SEV");
      console.log("responseDocBase", responseDocBase);
      if (close) {
        responseDocBase.staff = arrayToObject({
          key: "code",
          erase: ["code"],
          data: newStaff.map((e: stdObject) => {
            return {
              code: e.CODIA1,
              id: e.CODIA1 === 0 && sellerCode > 0 ? sellerCode : "",
              name:
                e.CODIA1 === 0 && sellerCode > 0
                  ? usersList[sellerCode].NOMUSU
                  : "",
            };
          }),
        });

        const responseDirectSaveDoc: stdObject = await startSendData(
          "saveDocument",
          responseDocBase,
        );

        if (responseDirectSaveDoc.success && responseDirectSaveDoc.status) {
          dispatch(
            updateRowData({
              type: responseDirectSaveDoc.type,
              data: [responseDirectSaveDoc.data],
            }),
          );
        } else {
          setMsg("error");
        }
      } else {
        responseDocBase.staff =
          sellerCode > 0
            ? [
                {
                  AGEIA2: sellerCode,
                  CODIA2: 0,
                  DOCIA2: windowValues.type,
                  NOMIA2: usersList[sellerCode].NOMUSU,
                  NUMIA2: 0,
                  SERIA2: user.CODSUC,
                },
              ]
            : [];

        const resultInfo = arrangeDocData(
          responseDocBase,
          packArrangeDoc,
          writeDataParams,
        );
        setDocValues({
          ...resultInfo,
          sectionId: windowValues.sectionId,
          title: t("p.newSEV"),
        });
        setDocModal("document");
      }
      closeMsg();
      setWindowValues({});
    } else {
      setMsg("error");
    }
  };

  const insertNewItem = (code: string, openList: boolean = false) => {
    if (openList) {
      openSelection(
        "ART",
        "ART",
        0,
        code === ""
          ? {}
          : {
              CODART: { value: code, value2: "", type: "text", mode: 1 },
            },
      );
    } else {
      const minCode = code.toLowerCase();
      const itemCode = Object.entries(items).find(
        ([key, value]: [string, stdObject | unknown]) =>
          key.toLowerCase() === minCode ||
          (typeof value === "object" &&
            value !== null &&
            "EANART" in value &&
            value.EANART !== "" &&
            value.EANART === minCode),
      );
      if (itemCode && itemCode[1]) {
        updateDocData({ ...itemCode[1], CODART: itemCode[0] }, "ART");
        return true;
      } else {
        let searchParams = { key: "CODART", order: 1 };
        let otherCodes: string | boolean | undefined = Object.keys(items).find(
          (key) => key.toLowerCase().startsWith(minCode),
        );
        if (!otherCodes) {
          otherCodes = Object.values(items).some((e: any) =>
            e.NOMART?.toLowerCase().includes(minCode),
          );
          searchParams = { key: "NOMART", order: 3 };
        }
        console.log("otherCodes", otherCodes);
        if (otherCodes) {
          openSelection("ART", "ART", 0, {
            [searchParams.key]: {
              value: code,
              value2: "",
              type: "text",
              mode: searchParams.order,
            },
          });
        } else {
          if (user.ARTN) {
            setMsg2("custom2");
            setModalData2({
              title: t("p.askCreateNewItem", { item: t("p.item") }),
              buttons: [
                {
                  label: t("p.create"),
                  onClick: () =>
                    openWindow({
                      msgName: "personItem",
                      modalInfo: {
                        label: t(`p.newART`, { item: t(`p.item`) }),
                        mainColor: colors[docValues.typeText],
                        type: "ART",
                        doc: "ART",
                        isEdit: 3,
                        code: "",
                        insertInDoc: code.trim(),
                      },
                      level: 1,
                    }),
                  color: colors.green,
                },
                {
                  label: t("p.cancel"),
                  onClick: () => closeMsg(2),
                  color: colors.darkGrey,
                },
              ],
            });
          } else {
            setMsg2("custom2");
            setModalData2({
              code: "warning",
              title: t("p.itemNotFound", { item: t("p.item") }),
            });
          }
        }
      }
    }
    return false;
  };

  const desactivateScrollDown = () => {
    setDocValues({ ...docValues, scrollDown: false });
  };

  const writeSelectiveRow = (e: stdObject) => {
    switch (modalData.step) {
      case 1:
      case 2:
        return [e.CODCLI, e.NOMCLI];
      case 4:
        return [e.NOMUSU];
      case "PSE":
        return [e.NOMPSE];
      case "PAG":
        return [e.NOMPAG];
      case "TAL":
        return [e.NOMTAL];
      default:
        return [
          {
            text: e.NOMART,
            style: { verticalAlign: "top" },
          },
          {
            text:
              e?.PREART && user.CODPAI in e.PREART
                ? pricesRates.map((v: stdObject) => [
                    v.NOMTAR,
                    v.CODTAR in e.PREART[user.CODPAI]
                      ? toPrice(e.PREART[user.CODPAI][v.CODTAR].PRELTA)
                      : "",
                  ])
                : "",
          },
        ];
    }
  };

  const writePersonItemInfo = ({
    type = "",
    data = {},
    level = 0,
  }: stdObject) => {
    let tempCommissions =
      "commissions" in data
        ? [
            {
              code: "COMM",
              value: data.commissions,
              tabId: 10,
              active: modalData2.isEdit > 1,
              onChange: (e: {
                target: { value: SetStateAction<string> };
              }) => {},
            },
          ]
        : [];

    return [
      ...tempCommissions,
      ...personItemField
        .filter((e) => e.TIPPER === type && e.ACTPER === 1)
        .sort((a, b) => b.ORDPER - a.ORDPER)
        .map((v) => {
          let value = data[v.CODPER];
          if (v.CODPER === "TIM") {
            value = typeof data.NAC === "string" ? convertAge(data.NAC) : "";
            value = Array.isArray(value) ? ageToString(value, t) : "";
          }
          return {
            label:
              v.CODPER === "COD" && v.TIPPER === "CLI"
                ? t(`c.ID`)
                : v.CODPER === "COD" && v.TIPPER === "PRO"
                  ? t(`c.ID2`)
                  : t(`c.${v.CODPER}`),
            code: v.CODPER,
            value,
            tabId: v.TABPER,
            active:
              modalData2.isEdit > 1
                ? v.CODPER !== "FOR" ||
                  (v.CODPER === "FOR" && Number(data.TIP) === 1)
                : false,
            ...getInputFormat(v.CODPER, {
              ...packInputFormat,
              modalData: modalData2,
              value: data[v.CODPER],
            }),
            style: { width: 300 },
            onChange: ["FAM", "DES"].includes(v.CODPER)
              ? (e: string) =>
                  updateWindowValue({
                    code: v.CODPER,
                    value: e,
                    level,
                    ...packUpdateWindow,
                  })
              : (e: { target: { value: SetStateAction<string> } }) =>
                  updateWindowValue({
                    code: v.CODPER,
                    value: ["WEB"].includes(v.CODPER)
                      ? e.target.value === "0"
                        ? 1
                        : 0
                      : e.target.value,
                    level,
                    ...packUpdateWindow,
                  }),
          };
        }),
    ];
  };

  const returnToDoc = (scrollDown: boolean = false) => {
    if (selectMode.serviceStep > 0) {
      setSelectMode({ ...selectMode, serviceStep: 0, active: false });
    } else if (docValues.type) {
      setDocModal("document");
      setSelectMode({ ...selectMode, active: false, searchParams: {} });
      if (scrollDown) {
        setDocValues({ ...docValues, scrollDown });
      } else if ("scrollDown" in docValues) {
        let tempDocData = docValues;
        delete tempDocData.scrollDown;
        setDocValues({ ...docValues });
      }
    }
  };

  const updateActiveDoc = useCallback(
    (data: stdObject) => {
      let updatedDoc = { ...data };
      updatedDoc.data = Object.keys(updatedDoc.data).reduce(
        (acc: stdObject, curr: string) => {
          acc[curr] = updatedDoc.data[curr].value;
          return acc;
        },
        {},
      );
      saveActiveDoc(user.CODUSU, updatedDoc);
    },
    [user],
  );

  const countTotals = useCallback(
    (tempData: stdObject) => {
      const docType = docValues.type;
      const type = docValues.itemType;
      const serviceTotal =
        `PRE${docType}` in docValues.data
          ? Number(tempData.data[`PRE${docType}`].value)
          : 0;
      const tempTotals: stdObject = { NET: 0, IMP: 0, TOT: 0 };
      const totalsData: stdObject = {
        NET:
          tempData.items.reduce(
            (acc: number, curr: stdObject) => acc + curr[`TOT${type}`],
            0,
          ) + serviceTotal,
        IMP:
          tempData.items.reduce(
            (acc: number, curr: stdObject) =>
              acc +
              (curr[`IMP${type}`] !== 0
                ? ((curr[`CAN${type}`] * curr[`PRE${type}`] -
                    (curr[`CAN${type}`] *
                      curr[`PRE${type}`] *
                      (curr[`DES${type}`] ?? 0)) /
                      100) *
                    curr[`IMP${type}`]) /
                  100
                : 0),
            0,
          ) +
          (`PIM${docType}` in tempData.data
            ? (tempData.data[`PIM${docType}`].value * serviceTotal) / 100
            : 0),
        TOT: 0,
        SAL: 0,
      };
      const getTotal = (e: string) => {
        switch (e) {
          case "TOT":
            return (
              tempTotals["NET"] +
              tempTotals["IMP"] -
              (tempData.data[`DES${docType}`]?.value ?? 0)
            );
          case "SAL":
            return (
              tempTotals["TOT"] - (tempData.data[`ABO${docType}`]?.value ?? 0)
            );
          default:
            return totalsData[e];
        }
      };
      Object.keys(totalsData).forEach((e: string) => {
        if (`${e}${docType}` in tempData.data) {
          tempTotals[e] = getTotal(e);
          tempData.data[`${e}${docType}`] = writeDataParams({
            type: docType,
            key: e,
            value: tempTotals[e],
            field: "data",
          });
        }
      });

      tempData.data = { ...tempData.data };
      tempData.updated = true;

      updateActiveDoc(tempData);
      setDocValues({ ...tempData });
    },
    [docValues, writeDataParams, updateActiveDoc],
  );

  const updateDocData = async (
    data: stdObject,
    direct: string = "",
    sltMode: stdObject = selectMode,
  ) => {
    if (docCustomersCodes.includes(sltMode.target)) {
      updatePersonDocData({
        t,
        sltMode,
        data,
        docValues,
        writeDataParams,
        ifCommissionPaid,
        updateDocTable,
        usersList,
        updatePrices,
        updateActiveDoc,
        setDocValues,
        setMsg2,
        setModalData2,
        closeMsg,
        logoutAction,
      });
    } else if (sltMode.goMenu === "ART" || direct === "ART") {
      updateItemDocData({
        data,
        docValues,
        user,
        items,
        setMsg,
        setModalData,
        setWindowValues,
        setDocValues,
        countTotals,
        logoutAction,
      });
    }
    returnToDoc(sltMode.goMenu === "ART" || direct === "ART");
  };

  const updatePrices = (data: stdObject) => {
    console.log("updatePrices", data);
    if (data.type === "SEV") {
      let servicePrice =
        items[data.data.INTSEV.value]?.PREART[user.CODPAI][data.person.TARCLI]
          ?.PRELTA ?? 0;
      servicePrice = getPriceOrOffer({
        data: items[data.data.INTSEV.value],
        price: servicePrice,
        country: user.CODPAI,
        rate: data.person.TARCLI,
      });
      data.data.PRESEV = writeDataParams({
        active: true,
        field: "data",
        itemCode: data.data.INTSEV.value,
        key: "PRE",
        type: "SEV",
        value: servicePrice,
      });
    }
    data.items = data.items.map((e: stdObject) => {
      let price =
        e[`ART${data.itemType}`] in items
          ? (items[e[`ART${data.itemType}`]]?.PREART[user.CODPAI][
              data.person.TARCLI
            ]?.PRELTA ?? 0)
          : e[`PRE${data.itemType}`];
      if (e[`ART${data.itemType}`] in items) {
        price = getPriceOrOffer({
          data: items[e[`ART${data.itemType}`]],
          price,
          country: user.CODPAI,
          rate: data.person.TARCLI,
        });
      }
      const lineTotal = e[`CAN${data.itemType}`] * price;
      return {
        ...e,
        [`PRE${data.itemType}`]: price,
        [`TOT${data.itemType}`]: applyDiscount(
          lineTotal,
          e[`DES${data.itemType}`],
        ),
      };
    });

    countTotals(data);
    closeMsg(2);
  };

  const checkIsLowCost = useCallback(
    ({ value, cost }: stdObject) => {
      const isLowCost = Number(value) < cost;
      if (isLowCost) {
        setMsg2("custom2");
        setModalData2({
          code: "warning",
          title: t("p.lowCostNotAllowed"),
          buttons: [
            {
              label: t("p.close"),
              onClick: () => closeMsg(2),
            },
          ],
        });
        return true;
      }
      return false;
    },
    [t, setMsg2, setModalData2, closeMsg],
  );

  const updateDocValue = () => {
    let tempData = docValues;
    tempData.updated = true;
    if (
      modalData.codeKey === "PRE" &&
      checkIsLowCost({
        value: windowValues.search,
        cost:
          modalData.field === "items"
            ? tempData[modalData.field][modalData.index][
                `PCO${docValues.itemType}`
              ]
            : tempData[modalData.field][`PCO${docValues.type}`].value,
      })
    )
      return true;

    if (modalData.field === "items") {
      tempData = recountTotals({
        tempData,
        index: modalData.index,
        key: modalData.codeKey,
        type: docValues.itemType,
        value: windowValues.search,
      });
    } else {
      tempData[modalData.field][modalData.codeKey + docValues.type] =
        writeDataParams({
          type: docValues.type,
          key: modalData.codeKey,
          value:
            modalData.codeKey === "FEC2" &&
            typeof windowValues.search === "string"
              ? windowValues.search.toString().split("T").join(" ")
              : modalData.codeKey === "PRE"
                ? Number(windowValues.search)
                : windowValues.search,
          field: modalData.field,
          itemCode: docValues.data?.INTSEV?.value ?? "",
        });
    }

    if (salesCodes.includes(docValues.type) && modalData.codeKey === "PRE") {
      tempData.commissions = updateCommissions({
        index:
          "index" in modalData
            ? docValues.items[modalData.index][`LIN${docValues.itemType}`]
            : 0,
        key: modalData.codeKey,
        value: windowValues.search,
        data: tempData.commissions,
      });
      countTotals(tempData);
    } else {
      updateActiveDoc(tempData);
      setDocValues({ ...tempData });
    }
    closeMsg();
  };

  const updateDocFilesList = (files: Array<string>) => {
    let tempData = docValues;
    tempData.updated = true;
    tempData["files"] = files;

    updateActiveDoc(tempData);
    setDocValues({ ...tempData });
  };

  const ifCommissionPaid = useCallback(
    (line: number | null = null) =>
      salesCodes.includes(docValues.type) && "commissions" in docValues
        ? docValues.commissions.some(
            (z: stdObject) =>
              z.PAGCOY > 0 &&
              (line === null ||
                (typeof line === "number" && z.LINCOY === line)),
          )
        : false,
    [docValues],
  );

  const updateDirectDocValue = useCallback(
    (field: string, key: string, value: string) => {
      if (["PRE", "PIM"].includes(key) && ifCommissionPaid(0)) {
        openPaidMsg();
      } else if (
        key === "PRE" &&
        typeof value === "number" &&
        checkIsLowCost({
          value,
          cost: docValues.data.PCOSEV.value,
        })
      ) {
        return false;
      } else {
        let tempData = docValues;
        tempData.updated = true;
        tempData[field][key + docValues.type] = writeDataParams({
          type: docValues.type,
          key,
          value:
            key === "PRE" && value === "another"
              ? docValues.data.PRESEV.value
              : key === "FEC2" && typeof value === "string"
                ? value.toString().split("T").join(" ")
                : key === "PRE"
                  ? Number(value)
                  : value,
          itemCode: ["PRE", "PIM"].includes(key)
            ? docValues.data.INTSEV.value
            : "",
          field: "data",
        });

        if (["PRE", "PIM"].includes(key)) {
          if (value === "another") {
            openInnerSelection({
              key,
              data: docValues.data.PRESEV,
              value: docValues.data.PRESEV.value,
              itemCode: docValues.data.INTSEV.value,
              ...packInnerSelection,
            });
          } else {
            countTotals(tempData);
            return true;
          }
        } else {
          updateActiveDoc(tempData);
          setDocValues({ ...tempData });
        }
      }
    },
    [
      docValues,
      packInnerSelection,
      ifCommissionPaid,
      openPaidMsg,
      checkIsLowCost,
      writeDataParams,
      // openInnerSelection,
      countTotals,
      updateActiveDoc,
      setDocValues,
    ],
  );

  const updateDocTable = (
    data: stdObject,
    tempModal = modalData,
    tempData = docValues,
  ) => {
    let mainKey: number | string | null = null;
    let newValues: stdObject = {
      type: tempData.type,
      key: null,
      field: tempModal.field,
      value: null,
      name: null,
      hideCode:
        tempModal.field === "staff" ||
        ["PAG", "PSE", "TAL"].includes(tempModal.codeKey),
    };
    let extraData = {};
    if (tempModal.field === "data") {
      mainKey = tempModal.codeKey + tempData.type;
      newValues = {
        ...newValues,
        value:
          tempModal.codeKey === "INT"
            ? data.CODART
            : data[`COD${tempModal.codeKey}`],
        name:
          tempModal.codeKey === "INT"
            ? data.NOMART
            : data[`NOM${tempModal.codeKey}`],
        key: tempModal.codeKey,
      };
      if (tempModal.codeKey === "INT") {
        const tempRate = tempData.person ? tempData.person.TARCLI : 1;
        let newPrice = getPriceOrOffer({
          data: items[data.CODART],
          price: data.PREART[user.CODPAI]
            ? data.PREART[user.CODPAI][tempRate]?.PRELTA
            : 0,
          country: user.CODPAI,
          rate: tempRate,
        });

        tempData.commissions = tempData.commissions.filter(
          (e: stdObject) => e.LINCOY !== 0,
        );
        Object.keys(docValues.staff).forEach((e: string) => {
          if (Number(docValues.staff[e].value) > 0) {
            const newComm: boolean | stdObject = createCommision({
              id: docValues.staff[e].value,
              name: docValues.staff[e].name,
              group: Number(e),
              itemCode: data.CODART,
              item: items[data.CODART],
              data: {
                [`LIN${docValues.itemType}`]: 0,
                [`CAN${docValues.itemType}`]: 1,
                [`ART${docValues.itemType}`]: data.CODART,
                [`NOM${docValues.itemType}`]: data.NOMART,
                [`PRE${docValues.itemType}`]: newPrice,
              },
              docValues,
            });
            if (typeof newComm === "object") {
              tempData.commissions.push(newComm);
            }
          }
        });

        extraData = {
          ["INTN" + tempData.type]: writeDataParams({
            type: tempData.type,
            key: "INTN",
            field: tempModal.field,
            value: data.NOMART,
          }),
          ["PRE" + tempData.type]: writeDataParams({
            type: tempData.type,
            key: "PRE",
            field: tempModal.field,
            itemCode: data.CODART,
            value: newPrice ?? 0,
            name: writeTax(data.TAX[user.CODPAI], t("c.IMP")),
          }),
          ["PCO" + tempData.type]: writeDataParams({
            type: tempData.type,
            key: "PCO",
            field: tempModal.field,
            value: data.PREPCO[user.CODPAI] ?? 0,
          }),
        };
      }
    } else {
      mainKey = tempModal.codeKey;
      tempData.commissions = tempData.commissions.filter(
        (e: stdObject) =>
          (typeof mainKey === "number" && e.GRUCOY !== mainKey) || e.PAGCOY > 0,
      );
      let commData: stdObject | boolean = false;
      if (data.CODUSU > 0 && typeof mainKey === "number") {
        if (
          `INT${tempData.type}` in tempData.data &&
          tempData.data[`INT${tempData.type}`] !== ""
        ) {
          if (
            (commData = createCommision({
              id: data.CODUSU,
              name: data.NOMUSU,
              group: mainKey,
              itemCode: tempData.data[`INT${tempData.type}`].value,
              item:
                tempData.data[`INT${tempData.type}`].value in items
                  ? items[tempData.data[`INT${tempData.type}`].value]
                  : false,
              data: {
                [`LIN${docValues.itemType}`]: 0,
                [`CAN${docValues.itemType}`]: 1,
                [`ART${docValues.itemType}`]:
                  tempData.data[`INT${tempData.type}`].value,
                [`NOM${docValues.itemType}`]:
                  tempData.data[`INTN${tempData.type}`].value,
                [`PRE${docValues.itemType}`]:
                  tempData.data[`PRE${tempData.type}`].value,
              },
              docValues,
            }))
          ) {
            tempData.commissions.push(commData);
          }
        }
        tempData.items.forEach((e: stdObject) => {
          if (
            typeof mainKey === "number" &&
            (commData = createCommision({
              id: data.CODUSU,
              name: data.NOMUSU,
              group: mainKey,
              itemCode: e[`ART${docValues.itemType}`],
              item:
                e[`ART${docValues.itemType}`] in items
                  ? items[e[`ART${docValues.itemType}`]]
                  : false,
              data: e,
              docValues,
            }))
          ) {
            tempData.commissions.push(commData);
          }
        });
      }
      newValues = {
        ...newValues,
        value: data.CODUSU,
        name: data.NOMUSU,
        key: Number(tempModal.codeKey),
      };
    }
    if (tempModal.field === "staff" && mainKey === 0) {
      [
        ["AGE", data.CODUSU],
        ["ANO", data.NOMUSU],
      ].forEach(
        (e: Array<any>) =>
          (tempData.data[e[0] + tempData.type] = writeDataParams({
            type: tempData.type,
            key: e[0],
            value: e[1],
            itemCode: "",
            field: "data",
            name: "",
            hideCode: false,
            paid: false,
          })),
      );
    }
    if (typeof mainKey === "number" || typeof mainKey === "string") {
      const finalTempData = {
        ...tempData,
        updated: true,
        [tempModal.field]: {
          ...tempData[tempModal.field],
          [mainKey]: writeDataParams(newValues),
          ...extraData,
        },
      };
      if (tempModal.returnData) {
        return finalTempData;
      } else {
        if (tempModal.codeKey === "INT") {
          countTotals(finalTempData);
        } else {
          updateActiveDoc(finalTempData);
          setDocValues({ ...finalTempData });
        }
      }
    }
    closeMsg();
    return {};
  };

  const updateItem = (
    index: number,
    code: string,
    value: string | number,
    params: stdObject = {},
  ) => {
    const type = docValues.itemType;
    if (ifCommissionPaid(docValues.items[index][`LIN${type}`])) {
      openPaidMsg();
    } else if (
      code === "CAN" &&
      !!docValues.items[index].BATCHES?.length &&
      docValues.items[index].BATCHES.reduce(
        (acc: number, curr: stdObject) => (acc += curr.CANBA0),
        0,
      ) > value
    ) {
      setMsg2("custom2");
      setModalData2({
        code: "warning",
        title: t(`p.quantityAccordanceBatch`),
        buttons: [
          {
            label: t("p.close"),
            onClick: () => closeMsg(2),
          },
        ],
      });
    } else {
      if (code === "PRE" && value === "another") {
        openInnerSelection({
          key: code,
          index,
          data: {
            key: code,
            field: "items",
            value: docValues.items[index][`PRE${type}`],
          },
          value: docValues.items[index][`PRE${type}`],
          itemCode: docValues.items[index][`ART${type}`],
          ...packInnerSelection,
        });
      } else {
        let tempData = docValues;
        if (["CAN", "DES", "IMP"].includes(code) && !value) {
          value = 0;
        }
        if (
          code === "CAN" &&
          itemsAutoStock.includes(
            items[tempData.items[index][`ART${docValues.itemType}`]]?.TIPART,
          ) &&
          user.STOROL === 3
        ) {
          tempData.items[index][`PEN${docValues.itemType}`] = value;
        }
        tempData = recountTotals({
          tempData,
          index,
          key: code,
          type,
          value,
          params,
        });
        if (
          salesCodes.includes(docValues.type) &&
          ["PRE", "CAN"].includes(code)
        ) {
          tempData.commissions = updateCommissions({
            index: tempData.items[index][`LIN${docValues.itemType}`],
            key: code,
            value,
            data: tempData.commissions,
          });
        }

        countTotals(tempData);
      }
    }
  };

  const askDeleteItem = (index: number) => {
    if (ifCommissionPaid(docValues.items[index][`LIN${docValues.itemType}`])) {
      openPaidMsg();
    } else {
      setMsg("deleteItemModal");
      setModalData({ index });
    }
  };

  const askDeleteMainInfo = async (active: boolean = false) => {
    const data = windowValues.info;
    const type = modalData.type;
    const id = modalData.id;
    if (typeof type === "string") {
      if (active) {
        setMsg2("loading");
        const payloadDeleteMainInfo = { type, id };
        console.log("payloadDeleteMainInfo", payloadDeleteMainInfo);
        const responseDeleteMainInfo: stdObject = await startSendData(
          "deleteMainInfo",
          payloadDeleteMainInfo,
        );
        console.log("responseDeleteMainInfo", responseDeleteMainInfo);
        const { success, status, error } = responseDeleteMainInfo;
        if (success) {
          if (status) {
            closeMsg();
            closeMsg(2);
            console.log("adfd", {
              type: type.toLowerCase() as keyof DataState,
              index: false,
              data,
            });
            dispatch(
              updateTable({
                type: type.toLowerCase() as keyof DataState,
                index: false,
                data,
              }),
            );
          } else {
            setMsg2("error");
            setModalData2({ label: error });
          }
        } else {
          setMsg2("error");
        }
      } else {
        setMsg2("custom2");
        setModalData2({
          title: t(titleTexts[type].title),
          label: data[titleTexts[type].nameCode],
          buttons: [
            {
              label: t("p.delete"),
              onClick: () => askDeleteMainInfo(true),
              color: colors.red,
            },
            {
              label: t("p.cancel"),
              onClick: () => closeMsg(2),
              color: colors.darkGrey,
            },
          ],
        });
      }
    }
  };

  const startDrawing = (data: stdObject, index: number) => {
    setMsg2("custom2");
    setModalData2({
      draw: { data: data.DRAWING, code: data.NUMSDD, original: data.ORIGINAL },
      buttons: [
        {
          label: t("p.update"),
          onClick: (drawing: string) => {
            let tempDocValues = docValues;
            tempDocValues.issues[index].DRAWING = drawing;
            setDocValues({ ...tempDocValues });
            closeMsg(2);
          },
          color: colors.green,
        },
        {
          label: t("p.cancel"),
          onClick: () => closeMsg(2),
          color: colors.darkGrey,
        },
      ],
    });
  };

  const openDictionary = (data: stdObject, index: number) => {
    let dictData: stdObject = convertDictData(data.TXTSDD);
    const selectedList = Object.keys(dictData.data ?? {});
    setMsg("dictionaryModal");
    setWindowValues({
      search: "",
      codes: selectedList,
      list: selectedList.map((e: string) => {
        return { code: e, name: dictData.data[e].name };
      }),
      table: dictList[dictData.dict].showAll
        ? dictList[dictData.dict].list.filter((e: stdObject) => {
            return !selectedList.includes(e.code);
          })
        : [],
    });
    setModalData({
      title: dictList[dictData.dict].name,
      step: "DICT",
      index,
      code: data.NUMSDD,
      showAll: dictList[dictData.dict].showAll,
      keysList: ["code", "name"],
      dict: dictData.dict,
    });
  };

  const openItemOptions = async (index: number, data: stdObject) => {
    try {
      setMsg("loading");
      const payloadDocRecords = {
        typeText: docValues.typeText,
        code:
          data.key === "PRE"
            ? docValues.data[`PRE${docValues.type}`].value
            : data[`ART${docValues.itemType}`],
        person: docValues.data[`CLI${docValues.type}`]?.value ?? 0,
      };
      console.log("payloadDocRecords", payloadDocRecords);

      const responseDocRecords = await sendData({
        endPoint: "callDocRecords",
        payload: payloadDocRecords,
        logoutAction,
      });
      console.log("responseDocRecords", responseDocRecords);

      const docRecords =
        responseDocRecords.success && responseDocRecords.status
          ? responseDocRecords.records
          : [];

      const priceValue =
        index === -1 ? data.value : data[`PRE${docValues.itemType}`];

      const costValue =
        index === -1
          ? docValues.data[`PCO${docValues.type}`].value
          : data[`PCO${docValues.itemType}`];

      const staffFiltered = staffList.filter(
        (e: stdObject) =>
          e.DOCIA1 === docValues.type && docValues.staff[e.CODIA1]?.value > 0,
      );

      const commissionsFilteredData = purchasesCodes.includes(docValues.type)
        ? []
        : docValues.commissions.filter(
            (v: stdObject) =>
              (index === -1 && v.LINCOY === 0) ||
              (index > -1 && v.LINCOY === data[`LIN${docValues.itemType}`]),
          );

      const findIsExistCommission = (code: number) => {
        return commissionsFilteredData.find(
          (v: stdObject) =>
            v.GRUCOY === code && v.AGECOY === docValues.staff[code].value,
        );
      };

      const extraParams: Array<stdObject> = purchasesCodes.includes(
        docValues.type,
      )
        ? [{}, {}]
        : [
            {
              price: priceValue,
              cost: costValue,
              commissions:
                salesCodes.includes(docValues.type) &&
                staffFiltered.map((e: stdObject) => {
                  const tempData = findIsExistCommission(e.CODIA1);
                  return tempData ? tempData.PROCOY : 0;
                }),
            },
            {
              info: [
                { label: "d.PRE", value: toPrice(priceValue) },
                salesCodes.includes(docValues.type) && {
                  label: "p.cost",
                  value: `${toPrice(costValue)} (${
                    costValue === 0
                      ? 0
                      : ((costValue * 100) / priceValue).toFixed(2)
                  }%)`,
                },
              ],
              commissions: staffFiltered.map((e: stdObject) => {
                const activeMode = findIsExistCommission(e.CODIA1);
                return {
                  code: e.CODIA1,
                  label: `${t(staffNames[e.CODIA1])} (${
                    docValues.staff[e.CODIA1]?.name
                  })`,
                  active: activeMode ? activeMode.PAGCOY === 0 : true,
                };
              }),
            },
          ];

      if (docValues.type === "COT") {
        delete extraParams[0].commissions;
        delete extraParams[1].commissions;
      }

      setWindowValues({
        description:
          index > -1 ? docValues.items[index][`OBS${docValues.itemType}`] : "",
        ...extraParams[0],
      });

      setModalData({
        title:
          index === -1
            ? docValues.data[`INTN${docValues.type}`].value
            : data[`NOM${docValues.itemType}`],
        index,
        records: { docs: responseDocRecords.docs, docRecords },
        // serie: data[`HUE${docValues.itemType}`] !== "",
        ...extraParams[1],
      });
      setMsg("itemOptionsModal");
    } catch (error) {
      console.log("openItemOptions error: ", error);
      setMsg("error");
    }
  };

  const getTotalProfit = (percentage: boolean = false) => {
    const commisionTotal =
      "commissions" in windowValues
        ? windowValues.commissions.reduce(
            (acc: number, curr: number) => acc + Number(curr),
            0,
          )
        : 0;

    return percentage
      ? 100 - ((windowValues.cost * 100) / windowValues.price + commisionTotal)
      : windowValues.price -
          windowValues.cost -
          (commisionTotal * windowValues.price) / 100;
  };

  const updateItemInfo = () => {
    let tempDocData = docValues;
    let trueIndex = 0;
    if (modalData.index > -1) {
      tempDocData.items[modalData.index][`OBS${docValues.itemType}`] =
        windowValues.description.trim();
      trueIndex =
        tempDocData.items[modalData.index][`LIN${docValues.itemType}`];
    }

    if (tempDocData.commissions && modalData.commissions) {
      const tempCommissions = tempDocData.commissions.filter(
        (e: stdObject) => e.LINCOY !== trueIndex || e.PAGCOY > 0,
      );

      modalData.commissions.forEach((e: stdObject, index: number) => {
        if (
          !tempCommissions.find(
            (v: stdObject) =>
              v.PAGCOY > 0 &&
              v.GRUCOY === e.code &&
              v.LINCOY === trueIndex &&
              v.AGECOY === docValues.staff[e.code].value,
          )
        ) {
          tempCommissions.push({
            DOCCOY: docValues.type,
            SERCOY: docValues.data[`SER${docValues.type}`].value,
            CODCOY: docValues.data[`COD${docValues.type}`].value,
            LINCOY: trueIndex,
            CANCOY: trueIndex
              ? docValues.items[modalData.index][`CAN${docValues.itemType}`]
              : 1,
            ARTCOY: trueIndex
              ? docValues.items[modalData.index][`ART${docValues.itemType}`]
              : docValues.data[`INT${docValues.type}`].value,
            NOMCOY: trueIndex
              ? docValues.items[modalData.index][`NOM${docValues.itemType}`]
              : docValues.data[`INTN${docValues.type}`].value,
            GRUCOY: e.code,
            AGECOY: docValues.staff[e.code].value,
            ANOCOY: docValues.staff[e.code].name,
            PROCOY: Number(windowValues.commissions[index]),
            PRECOY: trueIndex
              ? docValues.items[modalData.index][`PRE${docValues.itemType}`]
              : docValues.data[`PRE${docValues.type}`].value,
            PAGCOY: 0,
          });
        }
      });
      tempDocData.commissions = tempCommissions;
    }

    setDocValues({ ...tempDocData });
    closeMsg();
  };

  const saveWebSetting = async () => {
    const webFields = ["OKFTP"];
    if (
      !windowValues.webSettings.ACTWEB ||
      (windowValues.webSettings.ACTWEB &&
        webFields.every((e: string) => windowValues.webSettings[e]))
    ) {
      setMsg2("loading");
      const resultSaveWebSettings: stdObject = await sendData({
        endPoint: "saveWebSettings",
        payload: windowValues.webSettings,
        logoutAction,
      });
      console.log("resultSaveWebSettings: ", resultSaveWebSettings);
      closeMsg();
      closeMsg(2);
    } else if (
      windowValues.webSettings.ACTWEB &&
      webFields.some((e: string) => !windowValues[e])
    ) {
      let labelMsg = "";
      webFields.forEach((e) => {
        if (!windowValues[e]) labelMsg = e === "OKMAIL" ? t("p.email") : "FTP";
      });
      setMsg2("custom2");
      setModalData2({
        title: t("p.mustVerifyField"),
        label: labelMsg,
      });
    }
  };

  const openNotifications = () => {
    setMsg("newNotificationsModal");
    setWindowValues({
      text: "",
      date: "",
      search: "",
      users: [user.CODUSU],
    });
  };

  const openCalendar = () => {
    setCalendarModal({ ...calendarModal, open: true });
    setWindowValues({
      text: "",
      date: "",
      search: "",
      users: [user.CODUSU],
    });
  };

  const openActiveDocList = () => {
    const raw = secureLocalStorage.getItem("tempDocs");
    if (checkIfObject(raw)) {
      const key = String(user.CODUSU);
      const typedRaw = raw as Record<string, any>;
      if (key in typedRaw) {
        if (Object.keys(typedRaw[key]).length === 1) {
          Object.keys(typedRaw[key]).forEach((e: string) =>
            chooseDoc(typedRaw[key][e]),
          );
        } else {
          setActiveDocList(
            Object.keys(typedRaw[key]).reduce(
              (acc: Array<stdObject>, curr: string) => {
                acc.push(typedRaw[key][curr]);
                return acc;
              },
              [],
            ),
          );
          setMsg("activeDocuments");
        }
      }
    }
  };

  const createNewCalendar = ({ nextDate }: stdObject) => {
    setMsg("newCalendarModal");
    setModalData({ nextDate });
  };

  const chooseDoc = (data: number | stdObject) => {
    try {
      let initData =
        typeof data === "number" ? activeDocList[data] : (data as stdObject);

      initData = {
        ...initData,
        data: {
          ...initData.data,
          [`EST3${initData.type}`]: initData.prev[`EST3${initData.type}`],
        },
      };

      const resultInfo = arrangeDocData(
        initData,
        packArrangeDoc,
        writeDataParams,
      );
      setDocValues({
        ...resultInfo,
        sectionId: initData.sectionId,
        title:
          resultInfo.code > 0
            ? `${
                ["SAL", "PRE"].includes(resultInfo.type)
                  ? t(`c.${resultInfo.type}P`)
                  : t(`c.${resultInfo.type}`)
              } ${resultInfo.serie}-${resultInfo.code}`
            : t(`p.new${resultInfo.type}`, { code: t(`c.${resultInfo.type}`) }),
      });
      setDocModal("document");
      closeMsg();
    } catch (error) {
      console.log("chooseDoc error:", error);
    }
  };

  const addUpdateImage = (data: stdObject) => {
    let tempWindowValues = windowValues2;
    if ("new" in data) {
      tempWindowValues.IMG.images.push(data.new);
    } else if ("index" in data) {
      const { index, type, value } = data;
      tempWindowValues.IMG.images[index][type] = value;
    }
    setWindowValues2({ ...tempWindowValues });
  };

  const openUserInfo = async (data: stdObject) => {
    if (data.BLOUSU && Number(data.CODUSU) !== user.CODUSU) {
      setModalData2({ label: t("p.accessBlocked") });
      setMsg("error");
    } else {
      console.log("openUserInfo", data);
      startLoading();
      const payloadUserInfo = {
        id: data.CODUSU,
      };
      console.log("payloadUserInfo: ", payloadUserInfo);
      const resultUserInfo: stdObject = await startSendData(
        "callUser",
        payloadUserInfo,
      );
      console.log("resultUserInfo: ", resultUserInfo);
      if (resultUserInfo.success) {
        setMsg("userInfoModal");
        setModalData({
          title:
            data.CODUSU === "" ? t("p.newUser") : resultUserInfo.info.NOMUSU,
          id: data.CODUSU,
          codes: resultUserInfo.codes,
        });
        setWindowValues({
          info:
            data.CODUSU === ""
              ? {
                  SUC: sucsList.length > 0 ? sucsList[0].CODSUC : 0,
                }
              : resultUserInfo.info,
          ip: data.CODUSU === "" ? [] : resultUserInfo.ip,
        });
      } else {
        setModalData2({ label: resultUserInfo.error });
        setMsg("error");
      }
    }
  };

  const openRecordInfo = (data: stdObject, _: number) => {
    setMsg("custom1");
    setModalData({
      title: `${data.typeName}: (${data.code}) ${data.name !== "" ? data.name : data.code}`,
      JSONdata: data,
    });
  };

  const updateAccessLog = async () => {
    setMsg2("loading");
    const { IDIP0, USUIP0, ACTIP0, index } = windowValues;
    const payloadUpdateAccessLog = { id: IDIP0, user: USUIP0, active: ACTIP0 };
    console.log("payloadUpdateAccessLog: ", payloadUpdateAccessLog);
    const responseUpdateAccessLog = await sendData({
      endPoint: "updateAccessLog",
      payload: payloadUpdateAccessLog,
      logoutAction,
    });
    console.log("responseUpdateAccessLog: ", responseUpdateAccessLog);
    const { success, status } = responseUpdateAccessLog;
    if (success && status) {
      customUpdate.current = {
        accessLog: index,
        info: ACTIP0,
      };
      closeMsg(2);
      closeMsg();
    } else {
      setMsg2("error");
    }
  };

  const handleMainData = async (
    data: stdObject = windowValues,
    index: number = modalData.index,
    update: boolean = true,
  ) => {
    if (update && "inputs" in modalData) {
      for (let a = 0; a < modalData.inputs.length; a++) {
        if (
          modalData.inputs[a].require &&
          ((typeof windowValues[modalData.inputs[a].code] === "string" &&
            emptys.includes(windowValues[modalData.inputs[a].code].trim())) ||
            emptys.includes(windowValues[modalData.inputs[a].code]))
        ) {
          setMsg2("custom2");
          setModalData2({
            code: "warning",
            title: t("p.mandatoryField"),
            label: t(modalData.inputs[a].label),
          });
          return;
        }
      }
    }
    startLoading();
    console.log("handleMainData", data, index);
    const key = getKey("COD", data);
    const { code, realCode, name, newLabel, callUrl } = mainDataHandle[key];
    const area = data.AREA;
    delete data.AREA;

    let payloadHandleMainInfo = {
      area: emptys.includes(area) ? "v" : area,
      type: key,
      code: data[key === "DIN" && update ? realCode : code],
      data: update ? windowValues : {},
    };
    if (update) {
      delete payloadHandleMainInfo.data[key === "DIN" ? realCode : code];
      if (key === "CAJ") {
        payloadHandleMainInfo.data[
          payloadHandleMainInfo.data.FLOWCAJ.toString() === "2"
            ? "SALCAJ"
            : "ENTCAJ"
        ] = payloadHandleMainInfo.data.CANCAJ;
        payloadHandleMainInfo.data[
          payloadHandleMainInfo.data.FLOWCAJ.toString() === "2"
            ? "ENTCAJ"
            : "SALCAJ"
        ] = 0;
        delete payloadHandleMainInfo.data.CANCAJ;
        delete payloadHandleMainInfo.data.FLOWCAJ;
      }
      payloadHandleMainInfo.data = Object.entries(payloadHandleMainInfo.data);
    }
    console.log(
      "payloadHandleMainInfo: ",
      update ? "saveGlobalInfo" : callUrl,
      payloadHandleMainInfo,
    );
    const resultHandleMainInfo: stdObject =
      update || data[code] > 0
        ? await startSendData(
            update ? "saveGlobalInfo" : callUrl,
            payloadHandleMainInfo,
          )
        : { success: true, data: [data] };
    console.log("resultHandleMainInfo: ", resultHandleMainInfo);
    if (resultHandleMainInfo.success) {
      if (update) {
        switch (key) {
          case "MAR":
            dispatch(
              updateBrand({
                isNew: resultHandleMainInfo.new,
                data: resultHandleMainInfo.data,
              }),
            );
            break;
          case "CAJ":
          case "DIN":
            customUpdate.current = {
              mainInfo: key,
              info: resultHandleMainInfo.data,
            };
            break;
        }
        closeMsg();
        setWindowValues({});
        setModalData({});
      } else {
        if (resultHandleMainInfo.data[0]) {
          let resData = resultHandleMainInfo.data[0];
          resData.AREA = payloadHandleMainInfo.area;
          ["CANCAJ", "CANDIN"].forEach((e: string) => {
            if (e in resData) {
              resData[e] = toPrice(resData[e]);
            }
          });
          setMsg("mainDataModal");
          setModalData({
            area: payloadHandleMainInfo.area,
            key,
            title:
              index === -1
                ? t(newLabel)
                : key === "DIN"
                  ? t(`c.${resData.DOCDIN}`) +
                    ` ${resData.SERDIN}-${resData.CODDIN}`
                  : resData[name],
            name:
              key === "DIN"
                ? `${resData.DOCDIN}.${resData.SERDIN}-${resData.CODDIN}`
                : resData[name],
            code: resData[key === "DIN" ? realCode : code],
            index,
            inputs: getInputMainData(key, {
              t,
              bankAccountsList,
              expensesList,
              ratesList: area === "c" ? cPayments : vPayments,
            }),
          });
          if (key === "CAJ" && data[code] > 0) {
            resData = {
              ...resData,
              CANCAJ: resData.ENTCAJ + resData.SALCAJ,
              FLOWCAJ: resData.ENTCAJ !== 0 ? 1 : 2,
            };
          }
          setWindowValues(resData);
        }
      }
    } else {
      setModalData2({ label: resultHandleMainInfo.error });
      setMsg("error");
    }
  };

  const updateStaList = async (value: string) => {
    setMsg2("loading");
    const payloadStaList = { code: value };
    console.log("payloadStaList: ", payloadStaList);
    const resultStaList: stdObject = await startSendData(
      "callStaList",
      payloadStaList,
    );
    console.log("resultStaList: ", resultStaList);
    closeMsg(2);
    if (resultStaList.success) {
      return resultStaList.list.map((e: stdObject) => {
        return {
          value: e.CODDOC,
          label: e.NOMDOC,
        };
      });
    }
    return [];
  };

  const startCloneStationery = async () => {
    const { type, document, code } = windowValues.staData;
    const rowType = getItemType(type);
    const prevRowType = getItemType(document);
    console.log("c", windowValues.staData);
    if (code === "") {
    } else {
      setMsg2("loading");
      const responsePrevStationery = await sendData({
        endPoint: "callStationery",
        payload: { type: false, code },
        logoutAction,
      });
      console.log("responsePrevStationery", responsePrevStationery);

      const responseCurrStationery = await sendData({
        endPoint: "callStationery",
        payload: { type, code: "new" },
        logoutAction,
      });

      responsePrevStationery.parts.forEach((e: stdObject) => {
        let exists = false;
        const prevCode = getPrefix(e.PARPAR);
        if (e.PARPAR.endsWith(document)) {
          if (responseCurrStationery.doc.includes(prevCode + type)) {
            e.PARPAR = prevCode + type;
            exists = true;
          }
        } else if (e.PARPAR.endsWith(prevRowType)) {
          if (responseCurrStationery.rows.includes(prevCode + rowType)) {
            e.PARPAR = prevCode + rowType;
            exists = true;
          }
        } else {
          exists = true;
        }
        if (exists) {
          responseCurrStationery.parts.push(e);
        }
      });

      responseCurrStationery.data = {
        ...responsePrevStationery.data,
        CODDOC: 0,
        NOMDOC: "",
        TIPDOC: type,
      };

      console.log("responseCurrStationery", responseCurrStationery);
      openStationery(
        { ...responseCurrStationery, type, code: "init" },
        {
          setDocValues,
          setStationeryModal,
          setMsg,
          closeMsg,
          logoutAction,
        },
      );
      closeMsg(2);
    }
  };

  const openWebInfo = async (data: stdObject, index: number, id: string) => {
    startLoading();
    console.log("openWebInfo", data, index, id);
    const payloadMainInfo = {
      type: data.CODTAB,
      table: data.LOCTAB,
    };
    console.log("payloadWebInfo: ", payloadMainInfo);
    const resultWebInfo: stdObject = await startSendData(
      "callWebInfo",
      payloadMainInfo,
    );
    console.log("resultWebInfo: ", resultWebInfo);
    if (resultWebInfo.success) {
      setMsg("webInfo");
      setModalData({
        title: t(`c.${data.CODTAB}`),
        type: data.CODTAB,
        table: data.LOCTAB,
        index,
      });
      setWindowValues({ main: resultWebInfo.main, web: resultWebInfo.data });
    } else {
      setModalData2({ label: resultWebInfo.error });
      setMsg("error");
    }
  };

  const openMainInfo = async (data: stdObject, index: number, id: string) => {
    if (id === "ROL") {
      openRolInfo(
        { id: data.CODROL, index },
        {
          t,
          setMsg,
          setModalData,
          setModalData2,
          setWindowValues,
          logoutAction,
        },
      );
    } else {
      startLoading();
      console.log("openMainInfo", data, index);
      const type = ["CTPA", "VTPA"].includes(id) ? "TPA" : getKey("COD", data);
      const payloadMainInfo = {
        type: id ?? type,
        code: data[`COD${type ?? id}`],
      };
      console.log("payloadMainInfo: ", payloadMainInfo);
      const resultMainInfo: stdObject = await startSendData(
        "callMainInfo",
        payloadMainInfo,
      );
      console.log("resultMainInfo: ", resultMainInfo);
      if (resultMainInfo.success && resultMainInfo.data[0]) {
        setMsg("mainInfo");
        const extras =
          type === "SDA"
            ? resultMainInfo.forms.reduce(
                (acc: stdObject, curr: stdObject, index: number) => {
                  return {
                    ...acc,
                    [`TITSD0${index}`]:
                      curr.CODFOR === 0 ? t("p.default") : curr.NOMFOR,
                    [`FORSD0${index}`]: curr.CODFOR,
                    [`ACTSD0${index}`]: typeof curr.GRUSD0 === "number" ? 1 : 0,
                    [`GRUSD0${index}`]: curr.GRUSD0 ?? 0,
                    [`ORDSD0${index}`]: curr.ORDSD0 ?? 0,
                  };
                },
                {},
              )
            : {};
        setModalData({
          title:
            index === -1
              ? t(`p.new${id ?? type}`, { code: t(`c.${id ?? type}`) })
              : resultMainInfo.data[0][`NOM${type}`],
          type: id ?? type,
          id: resultMainInfo.data[0][`COD${type}`],
          index,
        });
        setWindowValues({
          info: { ...resultMainInfo.data[0], ...extras },
        });
      } else {
        setModalData2({ label: resultMainInfo.error });
        setMsg("error");
      }
    }
  };

  const openHeaderInfo = async (data: stdObject, index: number) => {
    console.log("openHeaderInfo", data);
    startLoading();
    const payloadHeaderInfo = {
      code: data.CODCAB,
      group: data.GRUCAB,
      user: data.USUCAB,
    };
    console.log("payloadHeaderInfo: ", payloadHeaderInfo);
    const resultHeaderInfo: stdObject = await startSendData(
      "callHeader",
      payloadHeaderInfo,
    );
    // console.log("resultHeaderInfo: ", resultHeaderInfo);
    if (resultHeaderInfo.success && resultHeaderInfo.headers[0]) {
      setMsg("headerInfo");
      setModalData({
        title: resultHeaderInfo.headers[0].CODCAB,
        codes: headerCodes,
        index,
      });
      setWindowValues({
        info: resultHeaderInfo.headers[0] ?? {},
      });
    } else {
      setModalData2({ label: resultHeaderInfo.error });
      setMsg("error");
    }
  };

  const openModal = (
    level = 1,
    type: string,
    params: stdObject,
    values: stdObject,
  ) => {
    let modalFunc = {
      msg: level === 2 ? setMsg2 : level === 3 ? setMsg3 : setMsg,
      data:
        level === 2
          ? setModalData2
          : level === 3
            ? setModalData3
            : setModalData,
      values:
        level === 2
          ? setWindowValues2
          : level === 3
            ? () => {}
            : setWindowValues,
    };
    modalFunc.msg(type);
    if (params) {
      modalFunc.data(params);
    }
    if (values) {
      modalFunc.values(params);
    }
  };

  const switchBranch = async (code: number) => {
    const responseSwitchBranch = await sendData({
      endPoint: "callBranch",
      payload: { code },
      logoutAction,
    });
    if (responseSwitchBranch.success && responseSwitchBranch.status) {
      secureLocalStorage.setItem(
        "branch",
        JSON.stringify(responseSwitchBranch.data),
      );
      directReload();
    }
  };

  const startExportSta = async () => {
    setMsg("loading");
    const responseExportSta = await sendData({
      endPoint: "getExportStationery",
      payload: {
        list: windowValues.exportStaList
          .filter((e: stdObject) => e.value)
          .map((e: stdObject) => e.CODDOC),
      },
      logoutAction,
    });
    const { success, status, data } = responseExportSta;
    if (success && status) {
      const blob = new Blob([data], {
        type: "text/plain;charset=utf-8",
      });

      const url = URL.createObjectURL(blob);

      const enlace = document.createElement("a");
      enlace.href = url;
      enlace.download = `stationery_${getCurrentDate(true)}.sta`;

      document.body.appendChild(enlace);
      enlace.click();

      document.body.removeChild(enlace);
      URL.revokeObjectURL(url);
    }
    closeMsg();
  };

  const startImportSta = async () => {
    setMsg("loading");
    const payloadImportSta = {
      list: windowValues.exportStaList
        .filter((e: stdObject) => e.value)
        .map((e: stdObject) => {
          delete e.value;
          return {
            data: e,
            parts: windowValues.parts.filter(
              (v: stdObject) => v.CODPAR === e.CODDOC,
            ),
          };
        }),
    };
    // console.log("payloadImportSta", payloadImportSta);

    const responseImportSta = await sendData({
      endPoint: "saveImportStationery",
      payload: payloadImportSta,
      logoutAction,
    });
    // console.log("responseImportSta",responseImportSta);
    const { success, status } = responseImportSta;
    if (success && status) {
      setMsg("custom1");
      setModalData({
        title: t("p.stationeryImported"),
      });
    } else {
      closeMsg();
    }
  };

  const createUserToken = async (
    index: number,
    data: stdObject,
    isOk = false,
  ) => {
    if (isOk) {
      setMsg("loading");
      const responseResetUserPassword = await sendData({
        endPoint: "tokenUserPassword",
        payload: { code: data.CODUSU },
        logoutAction,
      });
      const { success, status, pin } = responseResetUserPassword;
      if (success && status) {
        setMsg("custom1");
        setModalData({
          title: data.NOMUSU,
          label: t("p.enterThisPin", { pin }),
          buttons: [
            {
              label: t("p.close"),
              onClick: () => {
                closeMsg();
                setModalData({});
              },
              color: colors.blue,
            },
          ],
        });
      } else {
        closeMsg();
      }
    } else {
      setMsg("custom1");
      setModalData({
        title: data.NOMUSU,
        label: t("p.askResetUserPassword"),
        buttons: [
          {
            label: t("p.reset"),
            onClick: () => createUserToken(index, data, true),
            color: colors.green,
          },
          {
            label: t("p.cancel"),
            onClick: () => {
              closeMsg();
              setModalData({});
            },
            color: colors.blue,
          },
        ],
      });
    }
  };

  const openBatchRecords = async (data: stdObject) => {
    const { DESBA1, SERBA1, ARTBA1, IDBA1 } = data;
    setMsg("loading");
    const responseBatchRecords = await sendData({
      endPoint: "callBatchRecords",
      payload: { serie: SERBA1, item: ARTBA1, batch: IDBA1 },
      logoutAction,
    });
    const { success, status, records } = responseBatchRecords;
    if (success && status) {
      setMsg("custom1");
      setModalData({
        title: DESBA1,
        label: IDBA1,
        tableHeaders: [t("p.date"), t("p.document"), t("p.line"), t("p.qty")],
        table: records.map((e: stdObject) => {
          const { FECBA0, DOCBA0, SER2BA0, CODBA0, LINBA0, CANBA0 } = e;
          return {
            data: [
              FECBA0 ? convertDate({ info: FECBA0, time: false, t }) : " ",
              `${t(`c.${DOCBA0 === "PRE" ? "PREP" : DOCBA0 === "SAL" ? "SALP" : DOCBA0}`)} ${SERBA1}-${CODBA0}`,
              LINBA0,
              CANBA0,
            ],
            style: {
              textAlign: "center",
            },
          };
        }),
        isList: true,
        buttons: [
          {
            label: t("p.close"),
            onClick: () => {
              closeMsg();
              setModalData({});
            },
            color: colors.blue,
          },
        ],
      });
    } else {
      closeMsg();
    }
  };

  const startActionPack = {
    t,
    user,
    items,
    userAccess,
    docValues,
    documentAction,
    setDocValues,
    setStationeryModal,
    openModal,
    setMsg,
    setMsg2,
    setModalData,
    setModalData2,
    closeMsg,
    openInnerSelection,
    setWindowValues,
    guarantees,
    logoutAction,
  };

  const saveDocumentPack = {
    t,
    user,
    items,
    userAccess,
    dispatch,
    documentAction,
    setMsg,
    setMsg2,
    docValues,
    setStationeryModal,
    openModal,
    setWindowValues,
    setDocValues,
    setModalData,
    openInnerSelection,
    setModalData2,
    closeMsg,
    closeMsgDoc,
    guarantees,
    logoutAction,
  };

  const msgData: msgMainTypes = {
    loading: { code: "loading" },
    error: { code: "error", label: modalData2.label },
    accessBlocked: {
      code: "error",
      title: t("p.accessBlocked"),
    },
    activeDocuments: {
      title: t("p.activeDocuments"),
      table: activeDocList.map((e: stdObject, index: number) => {
        return (
          e.type && {
            data: [
              e.data[`COD${e.type}`] > 0
                ? `${t(`c.${e.type === "PRE" ? "PREP" : e.type}`)} ${e.data[`SER${e.type}`]}-${
                    e.data[`COD${e.type}`]
                  }`
                : t(`p.new${e.type}`, { code: t(`c.${e.types}`) }),
              `${e.data[`NOM${e.type}`]}`,
            ],
            style: {
              backgroundColor:
                index % 2 === 0 ? colors.lightGrey : colors.white,
            },
            onClick: () => {
              chooseDoc(index);
            },
          }
        );
      }),
      // isList: true,
      tableStyle: { height: 300, width: 300 },
      buttons: [
        {
          label: t("p.close"),
          onClick: closeMsg,
          color: colors.blue,
        },
      ],
    },
    askLogout: {
      label: t("p.askLogout"),
      buttons: [
        { label: t("p.logout"), onClick: logoutAction, color: colors.red },
        {
          label: t("p.cancel"),
          onClick: closeMsg,
          color: colors.darkGrey,
        },
      ],
    },
    custom1: modalData,
    custom2: modalData2,
    custom3: modalData3,
    userInfoModal: userInfoModal({
      t,
      modalData,
      windowValues,
      setWindowValues,
      updateWindowValue,
      packInputFormat,
      packUpdateWindow,
      saveUserInfo,
      closeMsg,
    }),
    headerInfo: {
      title: modalData.title,
      mainColor: modalData.mainColor,
      blocked: true,
      inputs: windowValues.info
        ? Object.entries(windowValues.info)
            .filter((e: any[]) => !headerCodes.includes(e[0]))
            .map((e: any[]) => {
              return {
                label: t(
                  headerTitles.find((o: stdObject) => o.code === e[0])?.label,
                ),
                value: e[1],
                ...getInputFormat(
                  headerTitles.find((o: stdObject) => o.code === e[0])?.type,
                  packInputFormat,
                ),
                style: { width: 300 },
                onChange: (v: { target: { value: SetStateAction<string> } }) =>
                  updateWindowValue({
                    key: "info",
                    code: e[0],
                    value:
                      headerTitles.find((o: stdObject) => o.code === e[0])
                        ?.type === "checkbox"
                        ? Number(v.target.value)
                          ? 0
                          : 1
                        : v.target.value,
                    ...packUpdateWindow,
                  }),
              };
            })
        : [],
      buttons: [
        {
          label: t("p.update"),
          onClick: saveHeaderInfo,
          color: colors.green,
        },
        {
          label: t("p.cancel"),
          onClick: closeMsg,
          color: colors.darkGrey,
        },
      ],
    },
    mainInfo: {
      title: modalData.title,
      // mainColor: modalData.mainColor,
      blocked: true,
      inputs: windowValues.info
        ? Object.entries(windowValues.info)
            .filter(
              (e: any[]) =>
                !e[0].startsWith("FORSD0") && !headerCodes.includes(e[0]),
            )
            .map((e: any[]) => {
              return {
                label: t(
                  e[0].startsWith("TITSD0")
                    ? e[1]
                    : e[0].startsWith("ACTSD0")
                      ? "p.active"
                      : e[0].startsWith("GRUSD0")
                        ? "p.group"
                        : e[0].startsWith("ORDSD0")
                          ? "p.order"
                          : areasTitles[modalData.type]?.find(
                              (o: stdObject) => o.code === e[0],
                            )?.label,
                ),
                value: e[1],
                ...getInputFormat(
                  e[0].startsWith("TITSD0")
                    ? "label"
                    : e[0].startsWith("ACTSD0")
                      ? "checkbox"
                      : e[0].startsWith("GRUSD0") || e[0].startsWith("ORDSD0")
                        ? "integer"
                        : areasTitles[modalData.type]?.find(
                            (o: stdObject) => o.code === e[0],
                          )?.type,
                  packInputFormat,
                ),
                style: { width: 300 },
                onChange: (v: { target: { value: SetStateAction<string> } }) =>
                  updateWindowValue({
                    key: "info",
                    code: e[0],
                    value:
                      e[0].startsWith("ACTSD0") ||
                      areasTitles[modalData.type]?.find(
                        (o: stdObject) => o.code === e[0],
                      )?.type === "checkbox"
                        ? Number(v.target.value)
                          ? 0
                          : 1
                        : v.target.value,
                    ...packUpdateWindow,
                  }),
              };
            })
        : [],
      buttons: [
        {
          label: modalData.index === -1 ? t("p.create") : t("p.update"),
          onClick: saveMainInfo,
          color: colors.green,
        },
        modalData.index > 0
          ? {
              label: t("p.delete"),
              onClick: () => askDeleteMainInfo(),
              color: colors.red,
            }
          : null,
        {
          label: t("p.cancel"),
          onClick: closeMsg,
          color: colors.darkGrey,
        },
      ],
    },
    webInfo: {
      title: modalData.title,
      blocked: true,
      inputs: [
        { label: t("p.remoteTable"), type: "label" },
        ...(windowValues.main
          ? Object.entries(windowValues.main).map((e: any[]) => {
              const isCheckBox = ["ACTTAB", "DELTAB"].includes(e[0]);
              return {
                label: e[0],
                value: e[1],
                ...getInputFormat(
                  isCheckBox ? "checkbox" : "text",
                  packInputFormat,
                ),
                style: { width: 300 },
                onChange: (v: { target: { value: SetStateAction<string> } }) =>
                  updateWindowValue({
                    key: "main",
                    code: e[0],
                    value: isCheckBox
                      ? Number(v.target.value)
                        ? 0
                        : 1
                      : v.target.value,
                    ...packUpdateWindow,
                  }),
              };
            })
          : []),
        { label: t("p.fields"), type: "label" },
        ...(windowValues.web
          ? Object.entries(windowValues.web).map((e: any[]) => {
              return {
                label: e[0],
                value: e[1],
                ...getInputFormat("checkbox", packInputFormat),
                style: { width: 300 },
                onChange: (v: { target: { value: SetStateAction<string> } }) =>
                  updateWindowValue({
                    key: "web",
                    code: e[0],
                    value: Number(v.target.value) ? 0 : 1,
                    ...packUpdateWindow,
                  }),
              };
            })
          : []),
      ],
      buttons: [
        {
          label: t("p.update"),
          onClick: () =>
            saveWebInfo({
              t,
              modalData,
              customUpdate,
              windowValues,
              openErrorMsg,
              startLoading,
              closeMsg,
              logoutAction,
            }),
          color: colors.green,
        },
        {
          label: t("p.cancel"),
          onClick: closeMsg,
          color: colors.darkGrey,
        },
      ],
    },
    rolInfoModal: rolInfoModal({
      t,
      saveRolInfo,
      windowValues,
      setWindowValues,
      pricesRates,
      packInputFormat,
      packUpdateWindow,
      modalData,
      askDeleteMainInfo,
      closeMsg,
    }),
    fieldInfoModal: fieldInfoModal({
      t,
      saveFieldInfo,
      windowValues,
      setWindowValues,
      modalData,
      closeMsg,
    }),
    personItem: {
      title: modalData2.label ?? modalData2.title,
      mainColor: modalData2.mainColor,
      blocked: true,
      // style: { minWidth: 300 },
      tabs:
        modalData2.type === "ART"
          ? [
              { code: 0, label: t("p.general") },
              { code: 1, label: t("p.prices") },
              { code: 2, label: t("p.images") },
              { code: 3, label: t("p.category") },
              // {code:4, label: t("p.stock") },
              // {code:5, label: t("p.components") },
              { code: 6, label: t("p.description") },
              //  modalData2.code !== "" && { code: 7, label: t("p.record") },
              // {code:8, label: t("p.series") },
              // {code:9, label: t("p.tickets") },
              versionsAccess[cVersion]?.includes("D") && {
                code: 10,
                label: t("p.commission"),
              },
            ]
          : [],
      inputs: writePersonItemInfo({
        type: modalData2.type,
        data: windowValues2,
        level: 1,
      }),
      buttons: [
        modalData2.code === "" ||
        (modalData2.code !== "" && modalData2.isEdit > 1)
          ? {
              label: t("p.save"),
              onClick: () =>
                savePersonItemData(
                  {
                    type: modalData2.type,
                    code: modalData2.code,
                    data: windowValues2,
                    level: 1,
                  },
                  {
                    t,
                    dispatch,
                    countries,
                    openErrorMsg,
                    personItemField,
                    updateDocData,
                    updateInternalPerson,
                    windowValues,
                    selectMode,
                    selectStep,
                    setMsg2,
                    setMsg3,
                    setWindowValues,
                    setWindowValues2,
                    setModalData2,
                    setModalData3,
                    closeMsg,
                    logoutAction,
                  },
                ),
              color: colors.green,
            }
          : null,
        modalData2.code !== "" && modalData2.isEdit > 1
          ? {
              label: t("p.delete"),
              onClick: () => deleteData(),
              color: colors.red,
            }
          : null,
        {
          label: t("p.cancel"),
          onClick: () => closeMsg(2),
          color: colors.darkGrey,
        },
      ],
    },
    payments: paymentsModal({
      t,
      user,
      cPayments,
      vPayments,
      windowValues,
      setWindowValues,
      windowValues2,
      setWindowValues2,
      startSavePayments,
      modalData,
      closeMsg,
    }),
    serviceModal: serviceModal({
      t,
      user,
      usersList,
      staffList,
      modalData,
      items,
      dispatch,
      openWindow,
      setDocValues,
      setDocModal,
      setWindowValues,
      setWindowValues2,
      packArrangeDoc,
      writeDataParams,
      windowValues,
      setMsg,
      setMsg2,
      setModalData,
      setModalData2,
      closeMsg,
      logoutAction,
    }),
    selectiveWindow: {
      title: modalData.title,
      label: modalData.label,
      mainColor: modalData.mainColor,
      blocked: true,
      inputs: modalData.inputs
        ? modalData.inputs.map((e: stdObject) => {
            return {
              label: e.NOMSDA,
              code: e.CODSDA,
              value:
                "issues" in windowValues ? windowValues.issues[e.CODSDA] : "",
              ...inputIssuesType(e.TIPSDA, e),
              style: { width: 300 },
              onChange: (v: { target: { value: SetStateAction<string> } }) => {
                let value =
                  e.TIPSDA === 0
                    ? typeof v.target.value === "string" &&
                      ["false", ""].includes(v.target.value)
                      ? true
                      : false
                    : e.TIPSDA === integerType
                      ? Math.round(Number(v.target.value))
                      : v.target.value;
                updateWindowValue({
                  code: e.CODSDA,
                  key: "issues",
                  value,
                  ...packUpdateWindow,
                });
              },
            };
          })
        : [
            {
              placeholder: modalData.placeholder,
              value:
                modalData.step === 4
                  ? windowValues2.search
                  : (windowValues.search ?? ""),
              type: "text",
              style: { width: "100%" },
              onChange: (e: { target: { value: SetStateAction<string> } }) =>
                filterTableList(e.target.value, false, dictCounter, {
                  windowValues:
                    modalData.step === 4 ? windowValues2 : windowValues,
                  setWindowValues:
                    modalData.step === 4 ? setWindowValues2 : setWindowValues,
                  modalData,
                  dictList,
                }),
            },
          ],
      table:
        modalData.step === 4 && "table" in windowValues2
          ? windowValues2.table.map((e: stdObject) => {
              return {
                data: writeSelectiveRow(e),
                onClick: () =>
                  selectStep(modalData.step + 1, e[modalData.codeKey]),
              };
            })
          : modalData.step !== 3
            ? windowValues.table?.length > 0
              ? windowValues.table.map((e: stdObject) => {
                  return {
                    data: writeSelectiveRow(e),
                    onClick: () =>
                      selectStep(modalData.step + 1, e[modalData.codeKey]),
                  };
                })
              : [{ data: [], onClick: () => {} }]
            : [],
      tableStyle: { height: 300, width: "100%" },
      isList: true,
      buttons: [
        modalData.step > 0 && {
          label: t("p.back"),
          onClick: () =>
            selectStep(modalData.step - (modalData.step === 3 ? 2 : 1), ""),
        },
        modalData.step > 0 && {
          label: modalData.step === 3 ? t("p.next") : t("p.skip"),
          onClick: () => selectStep(modalData.step + 1, ""),
          color: modalData.step === 3 ? colors.green : colors.orange,
        },
        {
          label: t("p.cancel"),
          onClick: closeMsg,
          color: colors.darkGrey,
        },
      ],
    },
    document: {
      ...docValues,
      onChange: (key: string, value: string) =>
        updateDirectDocValue("data", key, value.toString()),
      issues:
        docValues.issues &&
        docValues.issues.map((e: stdObject, index: number) => {
          return {
            ...e,
            [e.TIPSDD === 5 ? "onClick" : "onChange"]:
              e.TIPSDD === 5
                ? () => startDrawing(e, index)
                : e.TIPSDD === 8
                  ? () => openDictionary(e, index)
                  : (v: { target: { value: string } }) => {
                      updateIssue(
                        index,
                        e.TIPSDD,
                        e.TIPSDD === 0
                          ? v.target.value === "0"
                            ? "1"
                            : "0"
                          : v.target.value,
                        docValues,
                        setDocValues,
                      );
                    },
          };
        }),
      items:
        docValues.items &&
        docValues.items.map((e: stdObject, index: number) => {
          return {
            ...e,
            onChange: (value: string, code: string, params: stdObject = {}) =>
              updateItem(index, code, value, params),
            delete: () => askDeleteItem(index),
          };
        }),
      tabs: [
        {
          label: t("p.info"),
          Icon: ArticleIcon,
          onClick: () => {},
          color: colors.blue,
        },
        user[`${docValues.type}DOCUS1`] > 0 &&
          docValues.type &&
          docValues.data?.[`COD${docValues.type}`]?.value > 0 && {
            label: t("p.files"),
            Icon: FolderIcon,
            onClick: () => {},
            color: colors.blue,
          },
        // {
        //   label: t("p.location"),
        //   Icon: LocationOnIcon,
        //   onClick: () => {},
        //   color: colors.blue,
        // },
      ],
      buttons: [
        checkAccess("guarantee", packCheckAccess) && {
          label: t("c.C1G"),
          Icon: FileCopyIcon,
          onClick: () =>
            startAction(
              {
                action: "guarantee",
                code: docValues.data[`COD${docValues.type}`].value,
                msg: "askSaveDocBeforeGuarantee",
              },
              startActionPack,
            ),
        },
        checkAccess("void", packCheckAccess) && {
          label: t("p.void"),
          Icon: BlockIcon,
          onClick: () => {
            if (ifCommissionPaid()) {
              setMsg2("custom2");
              setModalData2({
                code: "warning",
                title: t("p.cantVoidwithPaid"),
                label: t("p.mustDeletePaidFirst"),
              });
            } else {
              setWindowValues(
                checkFields.reduce((acc: stdObject, curr: stdObject) => {
                  acc[curr.code] = 1;
                  return acc;
                }, {}),
              );
              setMsg2("voidDocModal");
            }
          },
          color: colors.red,
        },
        checkAccess("transfer", packCheckAccess) && {
          label: t("p.transfer"),
          Icon: MoveUpIcon,
          onClick: () =>
            startAction(
              {
                action: "transfer",
                code: docValues.data[`COD${docValues.type}`].value,
                msg: "askSaveDocBeforeTrans",
              },
              startActionPack,
            ),
          color: colors.lightBlue,
        },
        checkAccess("print", packCheckAccess) && {
          label: t("p.print"),
          code: "print",
          popup: shortcutCodes.print,
          Icon: PrintIcon,
          onClick: () =>
            startAction(
              {
                action: "print",
                code: docValues.data[`COD${docValues.type}`].value,
                msg: "askSaveDocBeforePrinting",
              },
              startActionPack,
            ),
        },
        docValues.forms?.length > 0 && {
          label: t("p.forms"),
          Icon: ChecklistIcon,
          onClick: () =>
            startAction(
              {
                action: "form",
                code: docValues.data[`COD${docValues.type}`].value,
                msg: "askSaveDocBeforePrinting",
              },
              startActionPack,
            ),
        },
        checkAccess("edit", packCheckAccess) && {
          label: t("p.save"),
          code: "save",
          popup: shortcutCodes.save,
          Icon: SaveIcon,
          onClick: () => startSaveDocument(saveDocumentPack),
          color: colors.green,
        },
      ],
    },
    docInput: {
      title: modalData.title,
      label: modalData.label,
      mainColor: modalData.mainColor,
      inputs: [
        {
          placeholder: modalData.placeholder,
          value: windowValues.search ?? "",
          type: modalData.type,
          style: modalData.style,
          innerStyle: modalData.innerStyle,
          inputStyle: modalData.inputStyle,
          autoFocus: true,
          onFocus: () =>
            modalData.codeKey === "PRE"
              ? setWindowValues({ ...windowValues, search: "" })
              : null,
          onChange: (e: { target: { value: SetStateAction<string> } }) =>
            Array.isArray(windowValues.table)
              ? filterTableList(
                  e.target.value,
                  false,
                  dictCounter,
                  packFilterTable,
                )
              : updateWindowValue({
                  code: "search",
                  value: e.target.value,
                  ...packUpdateWindow,
                }),
        },
      ],
      table: Array.isArray(windowValues.table)
        ? windowValues.table?.length > 0
          ? windowValues.table.map((e: stdObject) => {
              return {
                data: writeSelectiveRow(e),
                onClick: () =>
                  modalData.guarantee
                    ? createGuarantee(e, {
                        dispatch,
                        country: user.CODPAI,
                        accSerie: user.CODSUC,
                        docValues,
                        setMsg2,
                        setModalData2,
                        closeMsg,
                        closeMsgDoc,
                        logoutAction,
                      })
                    : updateDocTable(e),
              };
            })
          : [{ data: [], onClick: () => {} }]
        : [],
      isList: true,
      tableStyle: Array.isArray(windowValues.table)
        ? { height: 300, width: 300 }
        : false,
      buttons: [
        Array.isArray(windowValues.table)
          ? null
          : {
              label: t("p.update"),
              onClick: updateDocValue,
              color: colors.green,
            },
        {
          label: t("p.cancel"),
          onClick: closeMsg,
          color: colors.darkGrey,
        },
      ],
    },
    askToClose: {
      title: docValues.title,
      label:
        "action" in documentAction.current
          ? t(`p.${documentAction.current.msg}`, {
              guarantee: t("c.C1G").toLowerCase(),
            })
          : t("p.wantToSave"),
      buttons: [
        {
          label: t("p.save"),
          onClick: () => startSaveDocument(saveDocumentPack),
          color: colors.green,
        },
        !("action" in documentAction.current) && {
          label: t("p.noSave"),
          onClick: () => closeMsgDoc(true),
          color: colors.red,
        },
        {
          label: t("p.cancel"),
          onClick: () => {
            documentAction.current = {};
            closeMsg();
          },
          color: colors.darkGrey,
        },
      ],
    },
    itemBatchesModal: itemBatchesModal({
      t,
      user,
      docValues,
      modalData,
      windowValues,
      setMsg2,
      setModalData,
      setModalData2,
      setWindowValues,
      setDocValues,
      closeMsg,
    }),
    deleteItemModal: deleteItemModal({
      t,
      countTotals,
      docValues,
      modalData,
      closeMsg,
    }),
    dictionaryModal: dictionaryModal({
      t,
      dictList,
      dictCounter,
      docValues,
      setDocValues,
      modalData,
      setModalData,
      windowValues,
      setWindowValues,
      closeMsg,
    }),
    itemOptionsModal: itemOptionsModal({
      t,
      user,
      docValues,
      modalData,
      windowValues,
      packUpdateWindow,
      getTotalProfit,
      updateItemInfo,
      closeMsg,
    }),
    transferModal: transferModal({
      t,
      items,
      staffList,
      documentAction,
      docValues,
      packTransfer,
      userAccess,
      modalData,
      setMsg,
      setModalData,
      closeMsg,
      logoutAction,
    }),
    catModal: catModal({
      t,
      dispatch,
      modalData,
      windowValues,
      setWindowValues,
      updateWindowValue,
      setMsg2,
      setModalData2,
      closeMsg,
      logoutAction,
      packUpdateWindow,
    }),
    inventoryModal: inventoryModal({
      t,
      user,
      customUpdate,
      warehouses,
      dispatch,
      modalData,
      windowValues,
      setWindowValues,
      setModalData,
      setMsg,
      setMsg2,
      setModalData2,
      closeMsg,
      logoutAction,
    }),
    timeModal: timeModal({
      t,
      windowValues,
      windowValues2,
      setModalData2,
      setWindowValues,
      setWindowValues2,
      closeMsg,
    }),
    langModal: langModal({
      t,
      modalData,
      windowValues,
      setMsg,
      setModalData,
      setWindowValues,
      windowValues2,
      setWindowValues2,
      closeMsg,
      logoutAction,
    }),
    mainDataModal: mainDataModal({
      t,
      handleMainData,
      deleteMainData,
      packUpdateWindow,
      modalData,
      windowValues,
      setWindowValues,
      windowValues2,
      setWindowValues2,
      updateWindowValue,
      closeMsg,
    }),
    stationery: { ...docValues },
    occasionalModal: occasionalModal({
      t,
      docData: docValues,
      windowValues,
      updateDocData,
      setWindowValues,
      setMsg2,
      setDocValues,
      setModalData2,
      closeMsg,
      logoutAction,
    }),
    returnModal: returnModal({
      t,
      user,
      userAccess,
      openModal,
      sucsList,
      windowValues,
      setMsg2,
      setModalData2,
      setWindowValues,
      closeMsg,
      logoutAction,
    }),
    printFieldsModal: printFieldsModal({
      t,
      modalData,
      windowValues,
      setWindowValues,
      closeMsg,
    }),
    changeBranchModal: changeBranchModal({
      t,
      user,
      sucsList,
      setModalData,
      switchBranch,
      closeMsg,
    }),
    newNotificationsModal: newNotificationsModal({
      t,
      user,
      usersListArray,
      windowValues,
      setWindowValues,
      updateWindowValue,
      setModalData,
      packUpdateWindow,
      closeMsg,
    }),
    accessLogModal: accessLogModal({
      t,
      usersList,
      updateAccessLog,
      windowValues,
      setWindowValues,
      windowValues2,
      setWindowValues2,
      updateWindowValue,
      closeMsg,
    }),
    newCalendarModal: newCalendarModal({
      t,
      userAccess,
      closeMsg,
      modalData,
      openServiceModal,
    }),
    cloneStationeryModal: cloneStationeryModal({
      t,
      windowValues,
      closeMsg,
      modalData,
      startCloneStationery,
      updateStaList,
      setWindowValues,
    }),
    exportStaModal: exportStaModal({
      t,
      startImportSta,
      startExportSta,
      windowValues,
      setWindowValues,
      closeMsg,
    }),
    webSettingsModal: webSettingsModal({
      t,
      pricesRates,
      saveWebSetting,
      windowValues,
      setMsg2,
      setWindowValues,
      startSendData,
      closeMsg,
    }),
    voidDocModal: voidDocModal({
      t,
      setWindowValues,
      setMsg2,
      docValues,
      windowValues,
      closeMsg,
      closeMsgDoc,
      setModalData2,
      logoutAction,
    }),
    approveCommModal: approveCommModal({
      t,
      customUpdate,
      windowValues,
      setMsg,
      setWindowValues,
      closeMsg,
      logoutAction,
    }),
    docFieldsModal: docFieldsModal({
      t,
      saveAccess: userAccess.C.C1R,
      modalData,
      setModalData,
      logoutAction,
      closeMsg,
    }),
  };

  return {
    cVersion,
    userAccess,
    mainMenuheader,
    setMainMenuHeader,
    updateListCodeRef,
    openServiceModal,
    customUpdate,
    msg,
    msg2,
    msg3,
    docModal,
    msgData,
    setMsg,
    openMsg,
    closeMsg,
    setModalData,
    setDocModal,
    stationeryModal,
    calendarModal,
    askLogout,
    openWindow,
    windowValues,
    closeMsgDoc,
    closeCalendar,
    selectMode,
    setSelectMode,
    returnToDoc,
    updateDocData,
    desactivateScrollDown,
    activeDoc,
    alarms,
    statusDict,
    openItemOptions,
    insertNewItem,
    openActiveDocList,
    updateDocFilesList,
    askDeleteMainInfo,
    addUpdateImage,
    openUserInfo,
    openHeaderInfo,
    openRecordInfo,
    openMainInfo,
    handleMainData,
    selectStep,
    currentDate,
    calDocsList,
    setCalDocsList,
    openWebInfo,
    setDocValues,
    setStationeryModal,
    setWindowValues,
    setMsg2,
    docValues,
    setMsg3,
    setModalData2,
    setModalData3,
    documentAction,
    windowValues2,
    setWindowValues2,
    changeBranch,
    createUserToken,
    openNotifications,
    openCalendar,
    checkIfAllMsgClean,
    createNewCalendar,
    openBatchRecords,
  };
}
